"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = __importDefault(require("uuid"));
var api_1 = require("./api");
var shortcode_1 = require("./shortcode");
var noop = function () { };
var parseDate = function (date) {
    var _a = date.includes("/") ? date.split("/") : date.split("-"), year = _a[0], month = _a[1], day = _a[2];
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).valueOf();
};
var parseBool = function (value, defaultVal) {
    if (value === null || value === undefined) {
        return defaultVal;
    }
    if (value === "") {
        return !defaultVal;
    }
    return ["", "1", "true"].includes(value.toLowerCase());
};
var today = function () {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return now.valueOf();
};
var touchedAccessories = new Set();
var ALLOW_FALLBACK = (process.env.NODE_ENV !== "production" || process.env.CI);
var _SEARCH_PARAMS = new URLSearchParams((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.search);
var DEBUG = _SEARCH_PARAMS.has("debugapi") ? [null, "", "true"].includes(_SEARCH_PARAMS.get("debugapi")) : window.location.host.includes(":") || window.location.host.includes("-dev.") || window.location.host.includes("-test.");
var ALLOW_OVERRIDES = DEBUG;
var NOPRICES = (ALLOW_OVERRIDES && _SEARCH_PARAMS.has("noprices")) || process.env.REACT_APP_NO_PRICES === "true" || ((_c = process.env.REACT_APP_HIDE_PRICES) === null || _c === void 0 ? void 0 : _c.split(","));
var OVERRIDE_VALIDITY_DATE = _SEARCH_PARAMS.has("overridedate") ? _SEARCH_PARAMS.get("overridedate") : process.env.REACT_APP_OVERRIDE_DATE;
var OVERRIDE_VALIDITY_MIN_DATE = process.env.REACT_APP_FORCE_OVERRIDE_MIN_DATE && parseDate(process.env.REACT_APP_FORCE_OVERRIDE_MIN_DATE);
var OVERRIDE_VALIDITY = ALLOW_OVERRIDES && OVERRIDE_VALIDITY_DATE && parseDate(OVERRIDE_VALIDITY_DATE);
var DEBUG_IGNORE_2WAY = DEBUG && _SEARCH_PARAMS.has("ignore2way");
var DEBUG_IGNORE_3WAY = DEBUG && _SEARCH_PARAMS.has("ignore3way");
var PREORDER_YEAR = _SEARCH_PARAMS.get("preorder") || (((_d = process.env.REACT_APP_PREORDER_YEAR) === null || _d === void 0 ? void 0 : _d.includes("=")) ? process.env.REACT_APP_PREORDER_YEAR.split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {}) : (process.env.REACT_APP_PREORDER_YEAR || ""));
var IGNORE_INCLUDED_ACCESSORY_CONFLICTS = process.env.REACT_APP_NO_INCLUDED_ACCESSORY_CONFLICTS === "true" || _SEARCH_PARAMS.has("noincludedaccessoryconflicts");
var IGNORE_INCLUDED_ACCESSORY_VALIDATION = parseBool(process.env.REACT_APP_NO_INCLUDED_ACCESSORY_VALIDATION) || parseBool(_SEARCH_PARAMS.get("noincludedaccessoryvalidation"), true);
var IGNORE_ALL_ACCESSORY_VALIDATION = parseBool(process.env.REACT_APP_NO_ACCESSORY_VALIDATION) || parseBool(_SEARCH_PARAMS.get("noaccessoryvalidation"), true);
var DEFAULT_HOMOLOGATION = ((_e = process.env.REACT_APP_DEFAULT_HOMOLOGATION) === null || _e === void 0 ? void 0 : _e.includes("=")) ? process.env.REACT_APP_DEFAULT_HOMOLOGATION.split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {}) : (process.env.REACT_APP_DEFAULT_HOMOLOGATION || "NOH");
var DEFAULT_CURRENCY = process.env.REACT_APP_DEFAULT_CURRENCY || "CAD";
var PREFFERED_CURRENCY = (process.env.REACT_APP_PREFFERED_CURRENCY || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {});
var PREFERRED_ATTACH_POINTS = ((_f = process.env.REACT_APP_PREFERRED_ATTACH_POINTS) === null || _f === void 0 ? void 0 : _f.split(",")) || [];
var ATTACH_POINT_ALIASES = (process.env.REACT_APP_ATTACH_POINT_ALIASES || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {});
var BLOCKED_OPTION_GROUPS = (process.env.REACT_APP_BLOCKED_OPTION_GROUPS || "").split(",");
var EXCLUDED_OPTION_GROUPS = (process.env.REACT_APP_HIDDEN_OPTION_GROUPS || "").split(",");
var CONDITIONAL_OPTION_GROUPS = (process.env.REACT_APP_CONDITIONALLY_HIDDEN_OPTION_GROUPS || "").split(",");
var CONDITIONAL_SUMMARY_GROUPS = (process.env.REACT_APP_CONDITIONALLY_HIDDEN_SUMMARY_GROUPS || "").split(",");
var OPTION_GROUP_REDIRECT = (process.env.REACT_APP_OPTION_GROUP_REDIRECT || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    var _b;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = (_b = c[1]) === null || _b === void 0 ? void 0 : _b.split(";"), _a)));
}, {});
var OPTION_SORT_KEYS = (process.env.REACT_APP_OPTION_SORT_KEYS || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = parseFloat(c[1]), _a)));
}, {});
var SORT_CATEGORIES = (process.env.REACT_APP_SORT_CATEGORIES === "true") || _SEARCH_PARAMS.has("sortcategories");
var SORT_ACCESSORIES = (process.env.REACT_APP_SORT_ACCESSORIES === "true") || _SEARCH_PARAMS.has("sortaccessories");
var REMAP_PRCODES = (process.env.REACT_APP_REMAP_PRCODES || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {});
var NONE = "NONE";
// starting to reduce references to these strings by referencing them via 
// this instead (might want to extend that beyond the module)
var FCI;
(function (FCI) {
    FCI[FCI["Color"] = 0] = "Color";
    FCI[FCI["Engine"] = 1] = "Engine";
})(FCI || (FCI = {}));
var _CONFIGURABLE_FEATURE_CATEGORIES = ["BRP_COLOR", "BRP_{segment}_ENGINE"];
var ZL_ACCESSORY_GROUP = "ZL_ACCESSORY_GROUP_";
var postMessage = function (type, data) {
    console.log("ZL PostMessage: " + type, data);
    window.parent.postMessage(JSON.stringify({ event: type, params: data }), "*");
};
var isPreorderOnly = function (year, country) {
    if (typeof (PREORDER_YEAR) === "string") {
        if (PREORDER_YEAR === "true") {
            return true;
        }
        else if (PREORDER_YEAR === year) {
            return true;
        }
    }
    else if (PREORDER_YEAR[country] === year) {
        return true;
    }
    return false;
};
var makeManagable = function (saveData) {
    return __assign(__assign({}, saveData), { delete: function () {
            postMessage("brp_delete_build", saveData);
            try {
                window.localStorage.removeItem("SavedBuild." + saveData.uuid);
            }
            catch (_a) {
                console.log("local storage not available for saved builds");
            }
        }, isPreorderOnly: function () {
            return isPreorderOnly(saveData.year, saveData.locale.substr(3));
        }, preorder: function () {
            postMessage("brp_pre_order", saveData);
        }, requestQuote: function () {
            postMessage("brp_get_quote", saveData);
        }, share: function (channel, image, lock) {
            if (lock === void 0) { lock = false; }
            postMessage("brp_share", __assign(__assign({}, saveData), { channel: channel, image: image, locked: lock }));
        }, getPlatformId: function () { return saveData.model; }, getPackageId: function () { return saveData.package; }, getModelSku: function () { return saveData.unitsku; }, getModelYear: function () { return saveData.year; }, getPRCodes: function () { return __spreadArrays([
            saveData.unitsku,
            saveData.model,
            saveData.package
        ], saveData.selected.map(function (s) { return (s.featureid || s.accessorysku); })); } });
};
var checkValidityPeriod = function (item, now) {
    if (now === void 0) { now = today(); }
    if (OVERRIDE_VALIDITY) {
        now = OVERRIDE_VALIDITY;
    }
    if (OVERRIDE_VALIDITY_MIN_DATE && OVERRIDE_VALIDITY_MIN_DATE > now) {
        now = OVERRIDE_VALIDITY_MIN_DATE;
    }
    return (!item.validFrom || parseDate(item.validFrom) <= now) && (!item.validTo || parseDate(item.validTo) >= now);
};
var sanitizeCountryList = function (countries) {
    var _a;
    //Remap country codes the BRP are misusing
    return ((_a = countries) === null || _a === void 0 ? void 0 : _a.map(function (c) {
        switch (c) {
            case "SP":
                return "ES";
            default:
                return c;
        }
    })) || [];
};
var Configuration = /** @class */ (function () {
    function Configuration(blacklist, priorityList, ignoreAttachPoints, optimise, inject) {
        this.blacklist = blacklist;
        this.priorityList = priorityList;
        this.ignoreAttachPoints = ignoreAttachPoints;
        this.optimise = optimise;
        this.inject = inject;
    }
    return Configuration;
}());
var BuildSessionV2 = /** @class */ (function () {
    function BuildSessionV2(session, data, state, onBuildSessionUpdate, onConflict, onAttachChoice, onShortCode, familyCache, accessoryCache, config, saved, shortcode) {
        var _this = this;
        if (familyCache === void 0) { familyCache = undefined; }
        if (accessoryCache === void 0) { accessoryCache = undefined; }
        if (config === void 0) { config = undefined; }
        if (saved === void 0) { saved = false; }
        this.getOption = function (id) {
            try {
                return _this.getAccessoryItemBySku(_this.getUnit(), id);
            }
            catch (_a) {
                return _this.getFeatureItemById(id);
            }
        };
        this.session = session;
        this.data = data;
        this.state = state;
        this.onBuildSessionUpdate = onBuildSessionUpdate || noop;
        this.onConflict = onConflict || noop;
        this.onAttachChoice = onAttachChoice || noop;
        this.onShortCode = onShortCode || noop;
        this.familyCache = familyCache;
        this.accessoryCache = accessoryCache;
        this.config = config;
        this.saved = saved;
        this.shortcode = shortcode || state.shortcode;
        this.configurableFeatureCategories = _CONFIGURABLE_FEATURE_CATEGORIES;
        this.initConfigCats();
    }
    BuildSessionV2.prototype.getDataRoot = function () {
        try {
            var params = new URLSearchParams(window.location.search);
            var source = params.get("apidatasource");
            if (source) {
                return source.endsWith("/") ? source : source + "/";
            }
        }
        catch (_a) { }
        return "/";
    };
    BuildSessionV2.prototype.start = function (initialState, testDataSource) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __awaiter(this, void 0, void 0, function () {
            var data, root, language, useLanguageSpecificData, dataloc, response, json, err_1, response, unit, unitModel, state, validUnits, desiredFeatures, availableUnits, sortedAvailableUnits, _i, _q, um, country, familyCache, accessoryCache, optimise, config, buildSession;
            var _this = this;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        data = undefined;
                        root = this.getDataRoot();
                        language = this.session.locale.slice(0, 2);
                        useLanguageSpecificData = root === "/" || ((_a = root) === null || _a === void 0 ? void 0 : _a.includes("zlthunder.net"));
                        dataloc = undefined;
                        if (useLanguageSpecificData) {
                            dataloc = root + ["apidata", "v2", initialState.model.toLowerCase() + "_" + initialState.year, initialState.pkg.toLowerCase(), language].join("/") + ".json";
                        }
                        else {
                            dataloc = root + ["apidata", "v2", initialState.model.toLowerCase() + "_" + initialState.year, initialState.pkg.toLowerCase()].join("/") + ".json?exportAllUnits=true";
                        }
                        if (!!testDataSource) return [3 /*break*/, 8];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, fetch(dataloc)];
                    case 2:
                        response = _r.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _r.sent();
                        if (json && json.unitModelFamily) {
                            data = json.unitModelFamily;
                        }
                        else {
                            throw Error("Bad API data");
                        }
                        return [3 /*break*/, 5];
                    case 4: throw Error("Failed to fetch API data");
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _r.sent();
                        console.log(err_1);
                        if (ALLOW_FALLBACK) {
                            console.error("Failed to load real data. Was looking in ", dataloc);
                        }
                        else {
                            throw Error("Failed to load API data for " + [initialState.model.toLowerCase(), initialState.pkg.toLowerCase(), initialState.year, language].join(" "));
                        }
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        if (!ALLOW_FALLBACK) return [3 /*break*/, 10];
                        return [4 /*yield*/, testDataSource.v2[(initialState.model + "_" + initialState.year).toLowerCase()][initialState.pkg.toLowerCase()][language]()];
                    case 9:
                        response = (_r.sent());
                        if (!response || !response.unitModelFamily) {
                            throw Error("Failed to load fallback data:" + response);
                        }
                        data = response.unitModelFamily;
                        _r.label = 10;
                    case 10:
                        /*Should only do this in development, final should loudly fail*/
                        if (!data) {
                            throw Error("No API data");
                        }
                        this.session.currency = this.getAvailableCurrency(data, this.session.country, this.session.region, this.session.currency);
                        unit = undefined;
                        unitModel = undefined;
                        state = this.state;
                        if (state === null || state.unitsku === undefined) {
                            //Build initial state from data and initialState parameters, ideally this will be the same structure as saved
                            if (!data.unitModels || data.unitModels.length === 0) {
                                console.error(data.unitModels);
                                throw new Error("No unit models for " + initialState.model + "_" + initialState.year + " " + initialState.pkg);
                            }
                            unitModel = data.unitModels.find(function (um) { return um.id === (initialState.model); }) || data.unitModels[0];
                            if (!unitModel.units || unitModel.units.length === 0) {
                                throw new Error("No units for " + unitModel.id);
                            }
                            validUnits = [];
                            if (!initialState.unitsku) {
                                desiredFeatures = (_b = initialState.desiredFeatures) === null || _b === void 0 ? void 0 : _b.map(function (id) { return ({ featureid: id }); });
                                availableUnits = this.getValidUnits(unitModel, initialState.requiredFeatures, desiredFeatures);
                                //console.log("requiredFeatures", initialState.requiredFeatures);
                                //console.log("desiredFeatures", initialState.desiredFeatures);
                                //console.log("availableUnits", availableUnits);
                                if (availableUnits.length === 0) {
                                    throw new Error("No available units for " + unitModel.id);
                                }
                                sortedAvailableUnits = availableUnits.sort(function (lhs, rhs) { return (rhs.matches.length - lhs.matches.length) || (lhs.price - rhs.price); });
                                validUnits = availableUnits.map(function (a) { return a.unit; });
                                initialState.unitsku = sortedAvailableUnits[0].unit.id;
                            }
                            else {
                                validUnits = this.getValidUnits(unitModel).map(function (a) { return a.unit; });
                            }
                            unit = validUnits.find(function (u) { var _a, _b; return ((_a = u.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = initialState.unitsku) === null || _b === void 0 ? void 0 : _b.toLowerCase()); });
                            if (!unit) {
                                throw new Error("No units for " + initialState.unitsku);
                            }
                            state = {
                                uuid: initialState.buildId,
                                name: this.getMarketingName(unitModel, unit),
                                model: initialState.model,
                                year: initialState.year,
                                package: initialState.pkg,
                                homologation: this.getHomologationIdFromUnit(unit),
                                unitsku: unit.id,
                                created: new Date().toISOString(),
                                modified: new Date().toISOString(),
                                expiry: unit.validTo,
                                locked: false,
                                selected: __spreadArrays((unit.bundledFeatures || []).map(function (feature) {
                                    var _a;
                                    return ({
                                        featureid: feature.id,
                                        locked: ((_a = initialState.requiredFeatures) === null || _a === void 0 ? void 0 : _a.includes(feature.id)) ? 1 : 0,
                                        category: feature.type && feature.type.id || "",
                                        quantity: 1,
                                        attached: undefined
                                    });
                                }), this.getIncludedAccessories(unit).map(function (accessory) { return ({
                                    accessorysku: accessory.id,
                                    locked: _this.getQuantityRange(accessory).minimum,
                                    category: accessory.type && accessory.type.id || "",
                                    quantity: _this.getQuantityRange(accessory).minimum,
                                    attached: _this.getValidAttachPoints(accessory)
                                }); })),
                                segment: this.getSegment(initialState.model, data.type),
                                price: this.getPrice(unit.prices) || { amount: 0.00, currency: this.session.currency },
                                locale: this.session.locale,
                                region: this.session.region
                            };
                        }
                        else {
                            for (_i = 0, _q = data.unitModels || []; _i < _q.length; _i++) {
                                um = _q[_i];
                                unit = (um.units || []).find(function (u) { return u.id === state.unitsku; });
                                if (unit) {
                                    unitModel = um;
                                    break;
                                }
                            }
                            if (!unit) {
                                throw new Error("Unit not found: " + state.unitsku);
                            }
                            if (this.session.locale) {
                                country = this.session.locale.split("-")[1];
                                if (unit.availableCountries && !unit.availableCountries.includes(country)) {
                                    throw new Error("Unit " + state.unitsku + " not available in the current country (" + country + "), save originally from " + state.locale);
                                }
                            }
                        }
                        if (!unitModel) {
                            throw new Error("Unit Model not found");
                        }
                        familyCache = this.buildFamilyCache(unitModel);
                        accessoryCache = this.buildAccessoriesList(unit);
                        if (((_c = initialState.desiredAccessories) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                            initialState.desiredAccessories.foreach(function (accessorysku) {
                                var _a;
                                var existing = state.selected.find(function (a) { return a.accessorysku === accessorysku; });
                                if (existing) {
                                    existing.quantity += 1;
                                }
                                else {
                                    var accessory = (_a = accessoryCache) === null || _a === void 0 ? void 0 : _a.all.items.find(function (a) { return a.id === accessorysku; });
                                    if (accessory) {
                                        state.selected.push({
                                            accessorysku: accessorysku,
                                            locked: 0,
                                            category: accessory.type && accessory.type.id || "",
                                            quantity: 1,
                                            attached: _this.getValidAttachPoints(accessory)
                                        });
                                    }
                                }
                            });
                        }
                        optimise = ((_d = this.config) === null || _d === void 0 ? void 0 : _d.optimise) || ((data.modelYear || 0) >= (((_e = data.productLineUp) === null || _e === void 0 ? void 0 : _e.id) === "lynx" ? 2023 : 2022)) || (data.modelYear === 2021 && ((_f = data.productLineUp) === null || _f === void 0 ? void 0 : _f.id) === "canam-offroad" && (((_g = data.id) === null || _g === void 0 ? void 0 : _g.startsWith("ssv_defender")) || ((_h = data.id) === null || _h === void 0 ? void 0 : _h.startsWith("ssv_traxter")))) || false;
                        console.log("Checking if optimisations should be automatically enabled", { modelYear: data.modelYear, brand: (_j = data.productLineUp) === null || _j === void 0 ? void 0 : _j.id, optimise: optimise, prevOptimise: (_k = this.config) === null || _k === void 0 ? void 0 : _k.optimise });
                        config = new Configuration(((_l = this.config) === null || _l === void 0 ? void 0 : _l.blacklist) || [], ((_m = this.config) === null || _m === void 0 ? void 0 : _m.priorityList) || [], ((_o = this.config) === null || _o === void 0 ? void 0 : _o.ignoreAttachPoints) || false, optimise, (_p = this.config) === null || _p === void 0 ? void 0 : _p.inject);
                        buildSession = new BuildSessionV2(this.session, data, state, this.onBuildSessionUpdate, this.onConflict, this.onAttachChoice, this.onShortCode, familyCache, accessoryCache, config, true, this.shortcode || undefined);
                        this.onBuildSessionUpdate(buildSession);
                        if (buildSession.shortcode && this.onShortCode) {
                            this.onShortCode(buildSession, buildSession.shortcode);
                        }
                        return [2 /*return*/, buildSession];
                }
            });
        });
    };
    BuildSessionV2.prototype.getAvailableCurrency = function (data, country, region, preferredCurrency) {
        var _a, _b, _c, _d, _e;
        preferredCurrency = preferredCurrency || PREFFERED_CURRENCY[this.session.country];
        //Look through everything with a price and determine what currencies we have information for in the selected country
        var usage = {};
        var specialisation = {};
        for (var _i = 0, _f = data.unitModels || []; _i < _f.length; _i++) {
            var unitModel = _f[_i];
            for (var _g = 0, _h = this.getValidUnits(unitModel).map(function (m) { return m.unit; }); _g < _h.length; _g++) {
                var unit = _h[_g];
                var prices = __spreadArrays((unit.prices || []), (((_b = (_a = this.getAccessories(unit)) === null || _a === void 0 ? void 0 : _a.map(function (a) { return a.prices; })) === null || _b === void 0 ? void 0 : _b.reduce(function (p, a) { return __spreadArrays((p || []), (a || [])); }, [])) || []));
                for (var _j = 0, prices_1 = prices; _j < prices_1.length; _j++) {
                    var price = prices_1[_j];
                    if (!price.currency) {
                        continue;
                    }
                    if (specialisation[price.currency] === undefined) {
                        specialisation[price.currency] = 0;
                    }
                    specialisation[price.currency] += ((_c = price.amountsByCountry) === null || _c === void 0 ? void 0 : _c.length) || 0;
                    if ((preferredCurrency !== price.currency && ((_d = price.defaultAmounts) === null || _d === void 0 ? void 0 : _d.length)) || ((_e = price.amountsByCountry) === null || _e === void 0 ? void 0 : _e.find(function (a) { return a.countryCode && (typeof (a.countryCode) === "string" ? a.countryCode === country : a.countryCode.includes(country)); }))) {
                        if (usage[price.currency] === undefined) {
                            usage[price.currency] = 0;
                        }
                        usage[price.currency] += 1;
                    }
                }
            }
        }
        var availableCurrencies = Object.keys(usage).sort(function (l, r) { return usage[l] !== usage[r] ? usage[r] - usage[l] : specialisation[l] - specialisation[r]; });
        if (availableCurrencies.length > 0) {
            if (preferredCurrency && availableCurrencies.includes(preferredCurrency)) {
                return preferredCurrency;
            }
            return availableCurrencies[0];
        }
        return preferredCurrency || DEFAULT_CURRENCY;
    };
    BuildSessionV2.prototype.initConfigCats = function () {
        var _this = this;
        if (this.state.model) {
            this.configurableFeatureCategories = this.configurableFeatureCategories.map(function (cat) { return cat.replace("{segment}", _this.getModelType().toUpperCase()); });
        }
    };
    BuildSessionV2.prototype.dispatchUpdate = function (state, summary, accessoryCache, config) {
        var stateUpdated = state !== this.state;
        var saved = stateUpdated ? undefined : this.saved;
        var shortcode = stateUpdated ? undefined : this.shortcode || undefined;
        var updatedBuildSession = new BuildSessionV2(this.session, this.data, state, this.onBuildSessionUpdate, this.onConflict, this.onAttachChoice, this.onShortCode, this.familyCache, accessoryCache || this.accessoryCache, config || this.config, saved, shortcode);
        this.onBuildSessionUpdate(updatedBuildSession, summary);
        if (stateUpdated) {
            updatedBuildSession.autosave();
        }
    };
    BuildSessionV2.prototype.clone = function (onBuildSessionUpdate, onConflict, onAttachChoice, onShortCode, lock) {
        if (lock === void 0) { lock = false; }
        return new BuildSessionV2(this.session, this.data, __assign(__assign({}, this.state), { locked: this.locked() || lock }), onBuildSessionUpdate, onConflict, onAttachChoice, this.onShortCode, this.familyCache, this.accessoryCache, this.config);
    };
    BuildSessionV2.prototype.close = function () {
        postMessage("brp_close_build");
    };
    BuildSessionV2.prototype.getSaveData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var unit, shortcode, price;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unit = this.getUnit();
                        return [4 /*yield*/, this.getShortCode()];
                    case 1:
                        shortcode = _a.sent();
                        price = this.getTotalPrice();
                        return [2 /*return*/, __assign(__assign({}, this.state), { expiry: unit.validTo, price: __assign(__assign({}, price), { amount: price.total.amount, currency: price.total.currency }), locale: this.session.locale, region: this.session.region, segment: this.state.segment, shortcode: shortcode })];
                }
            });
        });
    };
    BuildSessionV2.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var saveData, _a, buildKey;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.locked()) {
                            throw "Build Locked";
                        }
                        _a = [{}];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        saveData = __assign.apply(void 0, [__assign.apply(void 0, _a.concat([_b.sent()])), { autosaved: false }]);
                        postMessage("brp_save_build", saveData);
                        try {
                            buildKey = "SavedBuild." + (saveData.autosaved ? "autosave" : saveData.uuid);
                            window.localStorage.setItem(buildKey, JSON.stringify(saveData));
                        }
                        catch (_c) {
                            console.log("local storage not available for saved build");
                        }
                        this.saved = true;
                        return [2 /*return*/, makeManagable(saveData)];
                }
            });
        });
    };
    BuildSessionV2.prototype.autosave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!this.locked()) return [3 /*break*/, 2];
                        _a = postMessage;
                        _b = ["brp_autosave_build"];
                        _c = [{}];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([__assign.apply(void 0, [__assign.apply(void 0, _c.concat([_d.sent()])), { autosaved: true }])]));
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.forceRequestShortCode = function () {
        this.getShortCode();
    };
    BuildSessionV2.prototype.getShortCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, waitForShortcode;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.shortcode === undefined)) return [3 /*break*/, 2];
                        this.shortcode = null;
                        _a = this;
                        return [4 /*yield*/, shortcode_1.save(this.session.userId, this.getPRCodes(), this.session.version, __assign(__assign({}, this.state), { locale: this.session.locale }), this.session.zlservice)];
                    case 1:
                        _a.shortcode = _b.sent();
                        if (this.onShortCode) {
                            this.onShortCode(this, this.shortcode);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.shortcode === null)) return [3 /*break*/, 4];
                        waitForShortcode = function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                return [2 /*return*/, new Promise(function (resolve) {
                                        var interval = setInterval(function () {
                                            if (_this.shortcode) {
                                                clearInterval(interval);
                                                resolve();
                                            }
                                        }, 50);
                                    })];
                            });
                        }); };
                        return [4 /*yield*/, waitForShortcode()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.shortcode];
                }
            });
        });
    };
    BuildSessionV2.prototype.hasUnsavedChanges = function () {
        return !this.saved;
    };
    BuildSessionV2.prototype.locked = function () {
        return this.state.locked === true;
    };
    BuildSessionV2.prototype.changePackage = function () {
        postMessage("brp_change_package");
    };
    BuildSessionV2.prototype.getFinance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = postMessage;
                        _b = ["brp_get_finance"];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([_c.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.finished = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreorderOnly()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.preOrder()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getQuote()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.getQuote = function () {
        return __awaiter(this, void 0, void 0, function () {
            var action, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        action = "brp_get_quote";
                        _a = postMessage;
                        _b = [action];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([_c.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.isPreorderOnly = function () {
        return isPreorderOnly(this.getModelYear(false), this.session.country);
    };
    BuildSessionV2.prototype.preOrder = function () {
        return __awaiter(this, void 0, void 0, function () {
            var action, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        action = "brp_pre_order";
                        _a = postMessage;
                        _b = [action];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([_c.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.promotion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var action, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        action = "brp_promotion";
                        _a = postMessage;
                        _b = [action];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([_c.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.share = function (channel, image, lock) {
        if (lock === void 0) { lock = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = postMessage;
                        _b = ["brp_share"];
                        _c = [{}];
                        return [4 /*yield*/, this.getSaveData()];
                    case 1:
                        _a.apply(void 0, _b.concat([__assign.apply(void 0, [__assign.apply(void 0, _c.concat([_d.sent()])), { channel: channel, image: image, locked: lock || this.locked() }])]));
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSessionV2.prototype.resetUnit = function () {
        var _this = this;
        if (this.locked()) {
            throw "Build Locked";
        }
        var unit = this.getUnit();
        this.dispatchUpdate(__assign(__assign({}, this.state), { selected: __spreadArrays((unit.bundledFeatures || []).map(function (feature) { return ({
                featureid: feature.id,
                locked: 0,
                category: feature.type && feature.type.id || "",
                quantity: 1,
                attached: undefined
            }); }), this.getIncludedAccessories(unit).map(function (accessory) { return ({
                accessorysku: accessory.id,
                locked: _this.getQuantityRange(accessory).minimum,
                category: accessory.type && accessory.type.id || "",
                quantity: _this.getQuantityRange(accessory).minimum,
                attached: _this.getValidAttachPoints(accessory)
            }); })) }));
    };
    BuildSessionV2.prototype.setConfig = function (blacklist, priorityList, ignoreAttachPoints, optimise, inject) {
        var _a, _b;
        if (ignoreAttachPoints === undefined) {
            ignoreAttachPoints = process.env.REACT_APP_IGNORE_ATTACH_POINTS === "true" || _SEARCH_PARAMS.has("ignoreattachpoints");
            if (!ignoreAttachPoints && process.env.REACT_APP_IGNORE_ATTACH_POINTS) {
                var rules = process.env.REACT_APP_IGNORE_ATTACH_POINTS.toLowerCase().split(",");
                if (rules.includes(this.getPlatformId().toLowerCase()) || rules.includes(this.getPlatformId().toLowerCase() + "_" + this.getModelYear(false))) {
                    ignoreAttachPoints = true;
                }
            }
        }
        if (optimise === undefined) {
            var param = _SEARCH_PARAMS.get("optimise");
            optimise = (DEBUG && param && ["", "true"].includes(param)) || ((_a = this.config) === null || _a === void 0 ? void 0 : _a.optimise) || false;
        }
        if (inject && ((_b = this.config) === null || _b === void 0 ? void 0 : _b.inject) !== inject) {
            var recursiveInject_1 = function (item) {
                if (Array.isArray(item)) {
                    item.forEach(function (v) { return recursiveInject_1(v); });
                }
                else if (typeof (item) === "object") {
                    for (var _i = 0, _a = Object.values(item); _i < _a.length; _i++) {
                        var value = _a[_i];
                        if (value) {
                            recursiveInject_1(value);
                        }
                    }
                    if (item.id && inject[item.id]) {
                        console.debug("Injecting data into " + item.id, inject[item.id], item);
                        Object.assign(item, inject[item.id]);
                    }
                }
            };
            console.debug("Attempting to inject data", inject);
            recursiveInject_1(this.data);
        }
        var config = new Configuration(blacklist, priorityList, ignoreAttachPoints, optimise, inject);
        var accessoryCache = undefined;
        try {
            accessoryCache = this.buildAccessoriesList(this.getUnit(), blacklist);
        }
        catch (_c) { }
        this.dispatchUpdate(this.state, undefined, accessoryCache, config);
    };
    BuildSessionV2.prototype.getCountryCode = function () {
        return this.session.country;
    };
    BuildSessionV2.prototype.getProductLineUp = function () {
        var pl = (this.data.productLineUp && this.data.productLineUp.id) ? this.data.productLineUp.id : "unknown-lineup";
        return pl.replace(/-/g, "").toLowerCase();
    };
    BuildSessionV2.prototype.getTranslatedUrl = function (data) {
        var _this = this;
        if (!data) {
            return undefined;
        }
        if (data.locales !== undefined) {
            var translation = data.locales.find(function (k) { return k.key === _this.session.locale; });
            if (translation && translation.value) {
                return translation.value;
            }
        }
        return data.default;
    };
    BuildSessionV2.prototype.getTranslationFromList = function (dataset, locale) {
        var _this = this;
        var _a, _b, _c;
        if (dataset) {
            var _loop_1 = function (data) {
                var translations = (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.locales) === null || _b === void 0 ? void 0 : _b.reduce(function (s, k) {
                    if (k.value && k.key === (locale || _this.session.locale)) {
                        s[k.value] = (s[k.value] || 0) + 1;
                    }
                    return s;
                }, {});
                if (translations && Object.keys(translations).length > 0) {
                    return { value: Object.keys(translations).sort(function (l, r) { return translations[r] - translations[l]; })[0] };
                }
            };
            for (var _i = 0, dataset_1 = dataset; _i < dataset_1.length; _i++) {
                var data = dataset_1[_i];
                var state_1 = _loop_1(data);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
            for (var _d = 0, dataset_2 = dataset; _d < dataset_2.length; _d++) {
                var data = dataset_2[_d];
                if ((_c = data) === null || _c === void 0 ? void 0 : _c.default) {
                    return data.default;
                }
            }
        }
        return "";
    };
    BuildSessionV2.prototype.getTranslation = function (data, locale) {
        var _this = this;
        if (!data) {
            return "";
        }
        if (data.locales !== undefined) {
            var translation = data.locales.find(function (k) { return k.key === (locale || _this.session.locale); });
            if (translation && translation.value) {
                return translation.value;
            }
        }
        return data.default || "";
    };
    BuildSessionV2.prototype.getPrice = function (priceData, includeSurcharges) {
        var _a, _b, _c;
        if (!((_a = priceData) === null || _a === void 0 ? void 0 : _a.length)) {
            if (NOPRICES === true || ((_b = NOPRICES) === null || _b === void 0 ? void 0 : _b.includes(this.session.country))) {
                return { amount: 0.00, currency: this.session.currency };
            }
            return undefined;
        }
        var lowestPrice = undefined;
        var lowestSurcharge = undefined;
        var now = today();
        var processPrice = function (currentLowest, price, currency) {
            if (!currency) {
                console.error("Currency not specified");
                return currentLowest;
            }
            var value = Math.max(price.value || 0, price.valueWithVAT || 0);
            if (price.value === undefined && price.valueWithVAT === undefined) {
                if (DEBUG) {
                    console.debug("Invalid price", price);
                }
            }
            else if (!checkValidityPeriod(price, now)) {
                if (DEBUG) {
                    console.debug("Invalid price validity range", price);
                }
            }
            else if (!currentLowest || value < currentLowest.amount) {
                return { amount: value, currency: currency };
            }
            return currentLowest;
        };
        for (var _i = 0, priceData_1 = priceData; _i < priceData_1.length; _i++) {
            var price = priceData_1[_i];
            if (this.session.currency && price.currency !== this.session.currency) {
                continue;
            }
            for (var _d = 0, _e = price.amountsByCountry || []; _d < _e.length; _d++) {
                var countryPrice = _e[_d];
                if (!countryPrice.countryCode || (typeof (countryPrice.countryCode) === "string" ? countryPrice.countryCode !== this.session.country : !countryPrice.countryCode.includes(this.session.country))) {
                    continue;
                }
                lowestPrice = processPrice(lowestPrice, countryPrice, price.currency);
            }
        }
        if (includeSurcharges === undefined || includeSurcharges) {
            // now including surcharges by default when we find them.
            for (var _f = 0, priceData_2 = priceData; _f < priceData_2.length; _f++) {
                var price = priceData_2[_f];
                for (var _g = 0, _h = price.surcharges || []; _g < _h.length; _g++) {
                    var surchargePrice = _h[_g];
                    if (surchargePrice.regionCode !== this.session.region) {
                        continue;
                    }
                    lowestSurcharge = processPrice(lowestSurcharge, surchargePrice, price.currency);
                }
            }
        }
        if (!lowestPrice) {
            for (var _j = 0, priceData_3 = priceData; _j < priceData_3.length; _j++) {
                var price = priceData_3[_j];
                if (price.currency !== this.session.currency) {
                    continue;
                }
                for (var _k = 0, _l = price.defaultAmounts || []; _k < _l.length; _k++) {
                    var defaultPrice = _l[_k];
                    lowestPrice = processPrice(lowestPrice, defaultPrice, price.currency);
                }
            }
        }
        if (lowestSurcharge && lowestPrice) {
            //console.log("Including a surcharge:", JSON.stringify(lowestSurcharge));
            lowestPrice.amount += lowestSurcharge.amount;
        }
        if (!lowestPrice && (NOPRICES === true || ((_c = NOPRICES) === null || _c === void 0 ? void 0 : _c.includes(this.session.country)))) {
            return { amount: 0, currency: this.session.currency };
        }
        return lowestPrice;
    };
    BuildSessionV2.prototype.formatPrice = function (price, negate) {
        return api_1.formatPrice(price, this.session.locale, negate);
    };
    BuildSessionV2.prototype.getModelType = function () {
        return this.state.model.split("_")[0];
    };
    BuildSessionV2.prototype.getModelRangeName = function (isOverridden) {
        if (isOverridden === void 0) { isOverridden = true; }
        var modelName = this.state.model.split("_")[1];
        if (window.overrideVehicles) {
            if (window.overrideVehicles.shouldApply && isOverridden) {
                modelName = window.overrideVehicles.model || modelName;
            }
        }
        return modelName;
    };
    BuildSessionV2.prototype.getModelYear = function (isOverridden) {
        if (isOverridden === void 0) { isOverridden = true; }
        var year = this.state.year;
        if (window.overrideVehicles) {
            if (window.overrideVehicles.shouldApply && isOverridden) {
                year = window.overrideVehicles.year || year;
            }
        }
        return year;
    };
    BuildSessionV2.prototype.getModelName = function () {
        return this.getTranslation(this.getUnitModel().name);
    };
    BuildSessionV2.prototype.getModelSegment = function () {
        return this.state.segment;
    };
    BuildSessionV2.prototype.getSegment = function (model, type) {
        type = type || undefined;
        if (type && type.id) {
            var segment = type.id;
            if (/\_/g.test(segment)) {
                segment = segment.split("_", 2)[1];
            }
            if (/\s/g.test(segment)) {
                segment = segment.replace(/\s/g, "-");
            }
            return segment.toUpperCase();
        }
        else {
            return model.split("_")[0].toUpperCase();
        }
    };
    BuildSessionV2.prototype.getMarketingName = function (unitModel, unit) {
        unit = unit || this.getUnit();
        if (unit && unit.name) {
            return this.getTranslation(unit.name);
        }
        unitModel = unitModel || this.getUnitModel();
        return this.getTranslation(unitModel.packageLabel);
    };
    BuildSessionV2.prototype.getDefaultMarketingImage = function () {
        var um = this.getUnitModel();
        if (um && um.defaultImage) {
            return this.getQualifiedUrl(this.getTranslatedUrl(um.defaultImage)) || "";
        }
        return "";
    };
    BuildSessionV2.prototype.getModelKeyFeatures = function () {
        var _this = this;
        var _a, _b;
        var keyFeatures = ((_a = this.getUnit()) === null || _a === void 0 ? void 0 : _a.keyFeatures) || ((_b = this.getUnitModel()) === null || _b === void 0 ? void 0 : _b.keyFeatures) || [];
        var keyFeatureStrings = keyFeatures.map(function (f) { return _this.getTranslation(f); }).filter(function (f) { return f; });
        return keyFeatureStrings.filter(function (f, i) { return keyFeatureStrings.indexOf(f) === i; });
    };
    BuildSessionV2.prototype.getPlatformId = function () {
        return this.state.model;
    };
    BuildSessionV2.prototype.getPackageId = function () {
        return this.state.package;
    };
    BuildSessionV2.prototype._getDefaultHomologation = function () {
        if (typeof (DEFAULT_HOMOLOGATION) === "string") {
            return DEFAULT_HOMOLOGATION;
        }
        return DEFAULT_HOMOLOGATION[this.session.country] || "";
    };
    BuildSessionV2.prototype.getHomologationIdFromUnit = function (unit) {
        var _a, _b, _c, _d, _e, _f;
        var homologationFeature = (_a = unit.bundledFeatures) === null || _a === void 0 ? void 0 : _a.find(function (f) { var _a; return (_a = f.id) === null || _a === void 0 ? void 0 : _a.includes("homologation"); });
        if (!((_c = (_b = homologationFeature) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.endsWith("none"))) {
            var parts = (_e = (_d = homologationFeature) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.split("_");
            if (parts) {
                return parts[((_f = parts) === null || _f === void 0 ? void 0 : _f.length) - 1].toUpperCase();
            }
        }
        return this._getDefaultHomologation();
    };
    BuildSessionV2.prototype.getHomologationId = function () {
        return this.state.homologation || this._getDefaultHomologation();
    };
    BuildSessionV2.prototype.getModelSku = function () {
        if (this.state) {
            return this.state.unitsku;
        }
        return "";
    };
    BuildSessionV2.prototype.getModifiedAt = function () {
        return Date.parse(this.state.modified);
    };
    BuildSessionV2.prototype.sanitizeFeatureCode = function (featureCode, code) {
        switch (featureCode) {
            case this.configurableFeatureCategories[FCI.Color]: {
                return code; //historically was doing .replace("color_", "").split(/_._/)[0]; // split is to cope with colour codes like "b_253_b_325_b_350" (not always 'b_', sometimes 'm_')
            }
            case this.configurableFeatureCategories[FCI.Engine]:
                {
                    var index = code.toLowerCase().indexOf("engine");
                    if (index >= 0) {
                        var codeStart = index + 7;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find the word engine in the code " + code + " but didn't?");
                    }
                    return code;
                }
            case "BRP_LYN_TRACK":
                {
                    var index = code.toLowerCase().indexOf("track");
                    if (index >= 0) {
                        var codeStart = index + 6;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find the word track in the code " + code + " but didn't?");
                    }
                    return code;
                }
            case "BRP_LYN_STARTER":
                {
                    var index = code.toLowerCase().indexOf("starter");
                    if (index >= 0) {
                        var codeStart = index + 8;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find the word starter in the code " + code + " but didn't?");
                    }
                    return code;
                }
            case "BRP_SEA_SEATING_CAPACITY":
                {
                    var index = code.toLowerCase().indexOf("capacity");
                    if (index >= 0) {
                        var codeStart = index + 9;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find the word starter in the code " + code + " but didn't?");
                    }
                    return code;
                }
            case "BRP_SEA_IBR":
                {
                    if (code && code.endsWith("_none")) {
                        var index = code.toLowerCase().indexOf("ibr");
                        if (index >= 0) {
                            var codeStart = index;
                            code = code.substr(codeStart);
                        }
                        else {
                            console.log("Was expecting to find the word ibr in the code " + code + " but didn't?");
                        }
                    }
                    else {
                        var index = code.toLowerCase().indexOf("ibr");
                        if (index >= 0) {
                            var codeStart = index + 4;
                            code = code.substr(codeStart);
                        }
                        else {
                            console.log("Was expecting to find the word ibr in the code " + code + " but didn't?");
                        }
                    }
                    return code;
                }
            case "BRP_SEA_HULL":
                {
                    var index = code.toLowerCase().indexOf("hull");
                    if (index >= 0) {
                        var codeStart = index + 5;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find teh word hull in the code " + code + " but didn't?");
                    }
                    return code;
                }
            case "BRP_SEA_DECK":
                {
                    var index = code.toLowerCase().indexOf("deck");
                    if (index >= 0) {
                        var codeStart = index + 5;
                        code = code.substr(codeStart);
                    }
                    else {
                        console.log("Was expecting to find teh word deck in the code " + code + " but didn't?");
                    }
                    return code;
                }
            default:
                {
                    if (code && code.endsWith("_none")) {
                        var type = code.split("_");
                        type = type.slice(1, type.length - 1);
                        if (type.length === 1) {
                            return type + "0";
                        }
                        else {
                            return type[0][0] + "0";
                        }
                    }
                    else {
                        if (featureCode === "BRP_LYN_COOLER_OPTION") {
                            return code.split("lyn_cooler_option_")[1];
                        }
                        else if (featureCode === "BRP_LYN_KIT_OPTION") {
                            return code.split("lyn_kit_option_")[1];
                        }
                        return code.split("_").reverse()[0];
                    }
                }
        }
    };
    BuildSessionV2.prototype.getFeatureCode = function (featureCategory, nosanitise) {
        var feature = this.state.selected.find(function (s) {
            return s.category == featureCategory && s.featureid;
        });
        if (feature && feature.featureid) {
            if (nosanitise) {
                return feature.featureid;
            }
            else {
                return this.sanitizeFeatureCode(featureCategory, feature.featureid);
            }
        }
        else {
            console.log("No " + featureCategory + " found in ", this.state.selected);
        }
        return "";
    };
    BuildSessionV2.prototype.getColorCode = function () {
        return this.getFeatureCode(this.configurableFeatureCategories[FCI.Color]);
    };
    BuildSessionV2.prototype.getTypeForItemId = function (id) {
        var unit = this.getUnit();
        var found = this.getAccessories(unit).find(function (a) { return a.id === id; });
        if (found && found.type && found.type.id) {
            return found.type.id;
        }
        return undefined;
    };
    BuildSessionV2.prototype.getCategoryForItemId = function (id) {
        var unit = this.getUnit();
        var found = this.getAccessories(unit).find(function (a) { return a.id === id; });
        if (found && found.category) {
            return found.category.map(function (c) { return c.id; });
        }
        return undefined;
    };
    BuildSessionV2.prototype.buildFamilyCache = function (unitModel) {
        var engCatName = this.configurableFeatureCategories[FCI.Engine];
        var validUnits = this.getValidUnits(unitModel);
        var engines = {};
        validUnits.forEach(function (vu) {
            var _a, _b;
            var engine = (_a = vu.unit.bundledFeatures) === null || _a === void 0 ? void 0 : _a.find(function (f) { var _a, _b; return ((_b = (_a = f) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.id) === engCatName; });
            if ((_b = engine) === null || _b === void 0 ? void 0 : _b.id) {
                engines[engine.id] = Math.max(engines[engine.id], vu.price);
            }
        });
        var orderedPricing = Array.from(new Set(Object.values(engines))).sort();
        var multiplier = orderedPricing.length < 3 ? 2 : 1;
        Object.keys(engines).forEach(function (e) { return engines[e] = orderedPricing.indexOf(engines[e]) * multiplier; });
        return { modelId: unitModel.id, validUnits: validUnits, engineBrackets: engines };
    };
    BuildSessionV2.prototype.getEngineBracket = function (id) {
        var _a, _b;
        if ((_a = this.familyCache) === null || _a === void 0 ? void 0 : _a.engineBrackets[id]) {
            return (_b = this.familyCache) === null || _b === void 0 ? void 0 : _b.engineBrackets[id];
        }
        return -1; // not an engine!
    };
    BuildSessionV2.prototype.getMarketingSummary = function () {
        var um = this.getUnitModel();
        if (um.packageDescription) {
            return this.getTranslation(um.packageDescription);
        }
        if (this.data.description) {
            return this.getTranslation(this.data.description);
        }
        return "";
    };
    BuildSessionV2.prototype.getPRCodes = function () {
        var _a, _b;
        var unit = this.getUnit();
        var platformId = this.getPlatformId();
        if (unit && unit.platform) {
            platformId = unit.platform;
        }
        var accessories = this.getAccessories(unit);
        var ignoreAttachPoints = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.ignoreAttachPoints) === true;
        var ignoreIncludedAccessories = ((_b = this.config) === null || _b === void 0 ? void 0 : _b.optimise) === true;
        //Will need expanding to include location information
        var baseOptions = [unit.id, platformId, this.getPackageId(), this.getHomologationId(), this.getCountryCode()];
        // keep feature codes (color/engine) at the start 
        var features = [];
        var acc = [];
        var _loop_2 = function (s) {
            var o = this_1.state.selected[s];
            if (o.featureid) {
                features.push(o.featureid);
                var bodgedFeatureCode = this_1.sanitizeFeatureCode(o.category, o.featureid);
                if (o.featureid !== bodgedFeatureCode) {
                    features.push(bodgedFeatureCode);
                }
            }
            else {
                if (o.accessorysku && (o.attached === undefined || o.attached.length > 0 || ignoreAttachPoints) && (!o.locked || !ignoreIncludedAccessories)) {
                    acc.push(o.accessorysku);
                    var item = accessories.find(function (a) { return o.accessorysku; });
                    if (item && item.contains) {
                        for (var _i = 0, _a = item.contains; _i < _a.length; _i++) {
                            var subitem = _a[_i];
                            acc.push(subitem);
                        }
                    }
                }
            }
        };
        var this_1 = this;
        for (var s = 0; s < this.state.selected.length; s++) {
            _loop_2(s);
        }
        return baseOptions.concat(features, ["MY" + this.getModelYear(false)], acc).map(function (prcode) { return REMAP_PRCODES[prcode] || prcode; });
    };
    BuildSessionV2.prototype.getUnitModel = function (id) {
        id = id || this.state.package;
        if (this.data && this.data.unitModels) {
            var unitModel = this.data.unitModels.find(function (um) { return um.id === id; });
            if (!unitModel && ALLOW_FALLBACK) {
                //console.log("Fallback - returning first model");
                unitModel = this.data.unitModels[0];
            }
            if (unitModel) {
                return unitModel;
            }
        }
        throw Error("Unknown Unit Model: " + id + " : " + (this.data.unitModels || []).map(function (um) { return um.id; }));
    };
    BuildSessionV2.prototype.getUnit = function (id, modelId) {
        id = id || this.state.unitsku;
        var um = this.getUnitModel(modelId);
        if (um.units) {
            var unit = um.units.find(function (u) { return u.id === id; });
            if (!unit && ALLOW_FALLBACK) {
                console.log("Fallback - returning first units");
                unit = um.units[0];
            }
            if (unit) {
                return unit;
            }
        }
        throw Error("Unknown Unit: " + um.id + "." + id);
    };
    BuildSessionV2.prototype.getAllOptions = function () {
        var options = [];
        var unitModel = this.getUnitModel();
        for (var _i = 0, _a = unitModel.units || []; _i < _a.length; _i++) {
            var unit_1 = _a[_i];
            for (var _b = 0, _c = unit_1.bundledFeatures || []; _b < _c.length; _b++) {
                var option = _c[_b];
                var category = option.type && option.type.id;
                if (category) {
                    var fi = this.getFeatureItem(option);
                    var validUnits = this.getValidUnits(unitModel, [option.id ? option.id : ""]);
                    if (validUnits.length > 0) {
                        options.push(fi);
                    }
                }
            }
        }
        //TODO: Filter Unique
        var unit = this.getUnit();
        for (var _d = 0, _e = this.getAccessories(unit); _d < _e.length; _d++) {
            var accessory = _e[_d];
            options.push(this.getAccessoryItem(accessory));
        }
        return options;
    };
    BuildSessionV2.prototype.getUnitFeatures = function (unitModel, requiredFeatures) {
        if (unitModel.unitFeatureFamily && unitModel.unitFeatureFamily.length > 0) {
            /*Never seen this in actual data samples, assuming it is the unique set of bundled features for all the units*/
            return unitModel.unitFeatureFamily;
        }
        /*Fallback: generate set manually*/
        var found = [];
        var features = [];
        for (var _i = 0, _a = this.getValidUnits(unitModel, requiredFeatures) || []; _i < _a.length; _i++) {
            var unit = _a[_i];
            for (var _b = 0, _c = unit.unit.bundledFeatures || []; _b < _c.length; _b++) {
                var feature = _c[_b];
                if (feature.id && feature.type && !found.includes(feature.id)) {
                    features.push(feature);
                    found.push(feature.id);
                }
            }
        }
        return features;
    };
    BuildSessionV2.prototype.getOptions = function (parentGroupId, maxTopLevelItems) {
        var _this = this;
        if (maxTopLevelItems === void 0) { maxTopLevelItems = 3; }
        var options = [];
        var unitModel = this.getUnitModel();
        var requiredFeatures = __spreadArrays(this.state.selected.filter(function (o) { return o.featureid !== undefined && (o.locked || (BLOCKED_OPTION_GROUPS.includes(o.category))); }).map(function (o) { return o.featureid; }));
        var unitFeatures = this.getUnitFeatures(unitModel, requiredFeatures);
        if (!parentGroupId || parentGroupId === api_1.ZL_OPTIONS) {
            var types = [];
            var categoryOptions_1 = {};
            for (var _i = 0, unitFeatures_1 = unitFeatures; _i < unitFeatures_1.length; _i++) {
                var option = unitFeatures_1[_i];
                if (option.type && option.id) {
                    var category = option.type.id;
                    if (!category || EXCLUDED_OPTION_GROUPS.includes(category)) {
                        continue;
                    }
                    if (!types.includes(category)) {
                        types.push(category);
                        categoryOptions_1[category] = [];
                        options.push({
                            id: category,
                            name: this.getTranslation(option.type.name),
                            categoryId: parentGroupId,
                            description: this.getTranslation(option.type.description)
                        });
                    }
                    categoryOptions_1[category].push(option.id);
                }
            }
            var availableAccessoryIDs_1 = this.getAccessoryIDs(this.getUnit(), undefined, true);
            var availableTopLevelSlots = maxTopLevelItems > 0 ? maxTopLevelItems - Math.min(availableAccessoryIDs_1.length, 1) : options.length;
            var availableOptionCategories_1 = Object.keys(categoryOptions_1).filter(function (category) {
                var options = new Set(categoryOptions_1[category]);
                if (options.size === 1 && Array.from(options)[0].endsWith("_none")) {
                    return false;
                }
                return !CONDITIONAL_OPTION_GROUPS.includes(category) || options.size > 1;
            });
            options = options.filter(function (o) { return availableOptionCategories_1.includes(o.id); });
            options.sort(function (l, r) { return (OPTION_SORT_KEYS[l.id] || 0) - (OPTION_SORT_KEYS[r.id] || 0); });
            if (!parentGroupId) {
                if (options.length > availableTopLevelSlots) {
                    options = options.slice(0, availableTopLevelSlots - 1);
                    options.push({
                        id: api_1.ZL_OPTIONS,
                        name: "OPTIONS",
                        categoryId: parentGroupId
                    });
                }
                if (options.length < maxTopLevelItems) {
                    options.push({
                        id: api_1.ZL_ACCESSORIES,
                        name: "ACCESSORIES",
                        categoryId: parentGroupId,
                        selected: this.state.selected.reduce(function (count, option) { return (count + (option.accessorysku !== undefined && !Object.values(OPTION_GROUP_REDIRECT).find(function (ro) { return ro.includes(option.category); }) && availableAccessoryIDs_1.includes(option.accessorysku) ? option.quantity : 0)); }, 0)
                    });
                }
            }
            else {
                options = options.slice(availableTopLevelSlots - 1);
            }
        }
        else if (unitFeatures.find(function (optionGroup) { return (optionGroup.type && optionGroup.type.id === parentGroupId); }) !== undefined) {
            for (var _a = 0, unitFeatures_2 = unitFeatures; _a < unitFeatures_2.length; _a++) {
                var option = unitFeatures_2[_a];
                if (option.type && option.type.id === parentGroupId) {
                    var validUnits = this.getValidUnits(unitModel, [option.id ? option.id : ""]);
                    if (validUnits.length > 0) {
                        options.push(this.getFeatureItem(option));
                    }
                }
            }
            //Hide alternative options if were locked to a specific one
            var lockedOptions = options.filter(function (o) { var _a; return ((_a = _this.state.selected.find(function (i) { return i.featureid === o.id; })) === null || _a === void 0 ? void 0 : _a.locked) === 1; });
            if (lockedOptions.length > 0) {
                options = lockedOptions;
            }
            //Hack to sort engines by class
            if (parentGroupId === this.configurableFeatureCategories[FCI.Engine]) {
                options.sort(function (l, r) { return _this.getEngineBracket(l.id) - _this.getEngineBracket(r.id); });
            }
        }
        else if (parentGroupId === api_1.ZL_ACCESSORIES || parentGroupId.startsWith(ZL_ACCESSORY_GROUP)) {
            var filter_1 = undefined;
            if (parentGroupId !== api_1.ZL_ACCESSORIES) {
                filter_1 = parentGroupId.substr(ZL_ACCESSORY_GROUP.length).split(",");
            }
            var unit = this.getUnit();
            var groupedAccessories = this.getAccessories(unit).reduce(function (c, a) {
                var _a;
                if (((_a = a.type) === null || _a === void 0 ? void 0 : _a.id) && !(filter_1 && !filter_1.includes(a.type.id))) {
                    if (!c[a.type.id]) {
                        c[a.type.id] = [];
                    }
                    c[a.type.id].push(a);
                }
                return c;
            }, {});
            var groups = {};
            for (var _b = 0, _c = Object.keys(groupedAccessories); _b < _c.length; _b++) {
                var groupId = _c[_b];
                var accessories = groupedAccessories[groupId];
                groups[groupId] = {
                    id: groupId,
                    categoryId: groupId,
                    name: this.getTranslationFromList(accessories.map(function (a) { var _a; return (_a = a.type) === null || _a === void 0 ? void 0 : _a.name; })),
                    description: this.getTranslationFromList(accessories.map(function (a) { var _a; return (_a = a.type) === null || _a === void 0 ? void 0 : _a.description; })),
                    selected: accessories.reduce(function (p, c) { var _a; return p + (((_a = _this.state.selected.find(function (o) { return o.accessorysku === c.id; })) === null || _a === void 0 ? void 0 : _a.quantity) || 0); }, 0),
                    validAttachPoints: accessories.map(function (a) { return a.id; }),
                    isNew: accessories.some(function (a) { return a.isNew === true; })
                };
            }
            options = Object.values(groups);
            if (filter_1) {
                options = options.sort(function (l, r) { var _a, _b; return (((_a = filter_1) === null || _a === void 0 ? void 0 : _a.indexOf(l.id)) || 0) - (((_b = filter_1) === null || _b === void 0 ? void 0 : _b.indexOf(r.id)) || 0); });
            }
            else if (SORT_CATEGORIES) {
                options = options.sort(function (l, r) { return l.name.localeCompare(r.name); });
            }
        }
        else {
            var unit = this.getUnit();
            for (var _d = 0, _e = this.getAccessories(unit, undefined, true); _d < _e.length; _d++) {
                var accessory = _e[_d];
                if (accessory.type && accessory.type.id === parentGroupId) {
                    options.push(this.getAccessoryItem(accessory));
                }
            }
            if (SORT_ACCESSORIES) {
                options.sort(function (lhs, rhs) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    var lhsContains = Math.min(((_a = lhs.contains) === null || _a === void 0 ? void 0 : _a.length) || 0, 1);
                    var rhsContains = Math.min(((_b = rhs.contains) === null || _b === void 0 ? void 0 : _b.length) || 0, 1);
                    if (lhsContains !== rhsContains) {
                        return rhsContains - lhsContains;
                    }
                    if ((((_c = lhs.validAttachPoints) === null || _c === void 0 ? void 0 : _c.length) || 0) > 0 && (((_d = rhs.validAttachPoints) === null || _d === void 0 ? void 0 : _d.length) || 0) > 0) {
                        var categoryOrder = ((_f = (_e = lhs.validAttachPoints) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.localeCompare(((_g = rhs.validAttachPoints) === null || _g === void 0 ? void 0 : _g[0]) || "")) || 0;
                        if (categoryOrder !== 0) {
                            return categoryOrder;
                        }
                    }
                    return lhs.name.localeCompare(rhs.name);
                });
            }
        }
        options = options.filter(function (o) {
            var _a;
            //Remove redirected options from the normal location
            return ((_a = parentGroupId) === null || _a === void 0 ? void 0 : _a.startsWith(ZL_ACCESSORY_GROUP)) || !Object.values(OPTION_GROUP_REDIRECT).find(function (ro) { return ro.includes(o.id); });
        }).map(function (o) {
            //Update id's of existing items to reference the redirects
            var redirects = OPTION_GROUP_REDIRECT[o.id];
            if (redirects && redirects.length > 0) {
                var redirect = redirects.length === 1 ? redirects[0] : ZL_ACCESSORY_GROUP + redirects.join(",");
                var redirectedOptions = _this.getOptions(redirect);
                if (redirectedOptions.length > 0) {
                    return __assign(__assign({}, o), { id: redirect, selected: redirectedOptions.reduce(function (t, o) { return t + (o.selected || 0); }, 0) });
                }
            }
            return o;
        });
        return options;
    };
    BuildSessionV2.prototype.getApplicableFees = function () {
        var feeTypes = {};
        var unit = this.getUnit();
        for (var _i = 0, _a = unit.fees || []; _i < _a.length; _i++) {
            var fee = _a[_i];
            if (!fee.type || !fee.type.id || (fee.region && fee.region !== this.session.region)) {
                continue;
            }
            if (feeTypes[fee.type.id] === undefined) {
                feeTypes[fee.type.id] = [];
            }
            feeTypes[fee.type.id].push(fee);
        }
        var fees = [];
        for (var _b = 0, _c = Object.values(feeTypes); _b < _c.length; _b++) {
            var feeType = _c[_b];
            var lowest = undefined;
            var now = today();
            for (var _d = 0, feeType_1 = feeType; _d < feeType_1.length; _d++) {
                var fee = feeType_1[_d];
                if (fee.amount) {
                    if (checkValidityPeriod(fee, now)) {
                        if (!lowest || (lowest.amount || 0) > fee.amount) {
                            lowest = fee;
                        }
                    }
                }
                else {
                    console.log("Invalid fee amount", fee.amount);
                }
            }
            if (lowest) {
                fees.push(lowest);
            }
        }
        return fees;
    };
    BuildSessionV2.prototype.sumPrices = function (prices) {
        if (prices.length === 0) {
            return undefined;
        }
        var total = prices.reduce(function (total, current) {
            if (total && current) {
                if (current.amount === 0) {
                    return total;
                }
                if (total.currency !== current.currency) {
                    throw "Attempting to add different currencies";
                }
                total.amount += current.amount;
            }
            return total;
        }, __assign(__assign({}, prices[0]), { amount: 0 }));
        total.amount = parseFloat(total.amount.toFixed(2));
        return total;
    };
    BuildSessionV2.prototype.getTotalPrice = function (add, remove, unitId) {
        var unit = this.getUnit(unitId);
        var emptyPrice = { amount: 0, currency: this.session.currency };
        var unitPrice = this.getPrice(unit.prices) || emptyPrice;
        if (unitPrice.amount <= 0) {
            console.log("No unit price!");
        }
        var selectedItems = this.state.selected;
        if (remove && add) {
            selectedItems = this.updateSelected(selectedItems, { add: add.map(function (a) { return a.id; }), remove: remove.map(function (a) { return a.id; }), targetUnitId: unitId }, "skipattach");
        }
        var accessoryPrices = [];
        var _loop_3 = function (accessory) {
            var selected = selectedItems.find(function (o) { return o.accessorysku === accessory.id; });
            if (selected) {
                var price = this_2.getPrice(accessory.prices);
                if (price) {
                    for (var i = selected.locked; i < selected.quantity; ++i) {
                        accessoryPrices.push(price);
                    }
                }
            }
        };
        var this_2 = this;
        for (var _i = 0, _a = this.getAccessories(unit); _i < _a.length; _i++) {
            var accessory = _a[_i];
            _loop_3(accessory);
        }
        var subtotal = this.sumPrices(__spreadArrays([this.getPrice(unit.prices, false) || emptyPrice], accessoryPrices));
        var fees = this.getApplicableFees();
        var total = this.sumPrices(__spreadArrays([unitPrice], accessoryPrices, fees));
        return { subtotal: subtotal, total: total };
    };
    BuildSessionV2.prototype.getSelectedFeatures = function (featureFamilyId) {
        var _this = this;
        var unit = this.getUnit();
        var groupFeatures = (unit.bundledFeatures || []).filter(function (feature) { return feature.type && feature.type.id === featureFamilyId; });
        return groupFeatures.map(function (feature) { return ({
            id: feature.id || "",
            categoryId: feature.type && feature.type.id,
            name: _this.getTranslation(feature.name),
            description: _this.getTranslation(feature.description),
            price: undefined,
            icon: undefined,
            selected: 1
        }); });
    };
    BuildSessionV2.prototype.getPricingDetails = function (financeParameters, add, remove, unitId) {
        var price = this.getTotalPrice(add, remove, unitId);
        if (!price) {
            return undefined;
        }
        if (!financeParameters) {
            return { subtotalValue: price.subtotal, totalValue: price.total };
        }
        var downpayment = financeParameters.downpayment, tradeIn = financeParameters.tradeIn, months = financeParameters.months, apr = financeParameters.apr;
        var monthlyPayment;
        if (apr === 0) {
            monthlyPayment = (price.total.amount - (downpayment + tradeIn)) / months;
        }
        else {
            var rpp = (apr * 0.01) / 12;
            //Is this calculation correct, I wouldn't have expected it to devolve at 0% APR
            monthlyPayment = (rpp * (price.total.amount - (downpayment + tradeIn))) / (1 - Math.pow(1 + rpp, -months));
        }
        var monthlyValue = { amount: monthlyPayment, currency: price.total.currency };
        return {
            subtotalValue: price.subtotal,
            totalValue: price.total,
            monthlyValue: monthlyValue
        };
    };
    BuildSessionV2.prototype.getPricingInfo = function (financeParameters, add, remove, unitId) {
        var _a;
        var details = this.getPricingDetails(financeParameters, add, remove, unitId);
        if (!details) {
            return undefined;
        }
        return {
            subtotal: this.formatPrice(details.subtotalValue),
            total: this.formatPrice(details.totalValue),
            monthly: this.formatPrice(details.monthlyValue),
            subtotalValue: details.subtotalValue.amount,
            totalValue: details.totalValue.amount,
            monthlyValue: (_a = details.monthlyValue) === null || _a === void 0 ? void 0 : _a.amount,
            currency: details.totalValue.currency
        };
    };
    BuildSessionV2.prototype.getSummary = function (includeIncluded) {
        var _this = this;
        var _a, _b;
        var unit = this.getUnit();
        var unitPrice = this.getPrice(unit.prices);
        var accessories = this.getAccessories(unit);
        var options = [];
        for (var _i = 0, _c = unit.bundledFeatures || []; _i < _c.length; _i++) {
            var feature = _c[_i];
            if (!((_b = (_a = feature) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.id) || EXCLUDED_OPTION_GROUPS.includes(feature.type.id)) {
                continue;
            }
            var items = [];
            if (OPTION_GROUP_REDIRECT[feature.type.id]) {
                for (var _d = 0, _e = OPTION_GROUP_REDIRECT[feature.type.id]; _d < _e.length; _d++) {
                    var redirect = _e[_d];
                    items = items.concat(this.getOptions(redirect));
                }
            }
            if (items.length == 0) {
                items = this.getOptions(feature.type.id);
            }
            if ((items.length <= 1 && CONDITIONAL_SUMMARY_GROUPS.includes(feature.type.id)) || (items.length === 1 && items[0].id.endsWith("_none"))) {
                continue;
            }
            items = items.filter(function (v) { return (v.selected || 0) > 0; });
            var itemPrices = items.reduce(function (p, c) {
                var _a, _b;
                var item = accessories.find(function (a) { return a.id == c.id; });
                if ((_b = (_a = item) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b.length) {
                    var price = _this.getPrice(item.prices);
                    if (price) {
                        return __spreadArrays(p, [price]);
                    }
                }
                return p;
            }, []);
            options.push({
                id: feature.type.id,
                items: items,
                name: this.getTranslation(feature.type.name),
                subtotal: itemPrices.length > 0 ? this.formatPrice(this.sumPrices(itemPrices)) : ""
            });
        }
        var groupedSelectedAccessories = {};
        var accessoryPrices = [];
        var accSources = [];
        if (includeIncluded === undefined || includeIncluded) {
            accSources.push(this.getIncludedAccessories(unit));
        }
        accSources.push(accessories);
        for (var s = 0; s < accSources.length; s++) {
            var _loop_4 = function (accessory) {
                var accessorytype = (accessory.type && accessory.type.id) ? accessory.type : { id: "" };
                if (Object.values(OPTION_GROUP_REDIRECT).find(function (r) { return r.includes(accessorytype.id || ""); })) {
                    return "continue";
                }
                var selected = this_3.state.selected.find(function (o) { return o.accessorysku === accessory.id; });
                if (selected) {
                    if (groupedSelectedAccessories[accessorytype.id || ""] === undefined) {
                        groupedSelectedAccessories[accessorytype.id || ""] = {
                            name: this_3.getTranslation(accessorytype.name),
                            items: []
                        };
                    }
                    groupedSelectedAccessories[accessorytype.id || ""].items.push(this_3.getAccessoryItem(accessory));
                    var price = this_3.getPrice(accessory.prices);
                    if (price) {
                        for (var i = selected.locked; i < selected.quantity; ++i) {
                            accessoryPrices.push(price);
                        }
                    }
                }
            };
            var this_3 = this;
            for (var _f = 0, _g = accSources[s] || []; _f < _g.length; _f++) {
                var accessory = _g[_f];
                _loop_4(accessory);
            }
        }
        var applicableFees = this.getApplicableFees();
        var fees = applicableFees.map(function (f) { return ({ name: _this.getTranslation(f.type && f.type.name), price: _this.formatPrice(f) }); });
        var accsum = this.sumPrices(accessoryPrices);
        var subtotalprice = this.sumPrices(__spreadArrays([this.getPrice(unit.prices, false) || { amount: 0, currency: "" }], accessoryPrices));
        var totalprice = this.sumPrices(__spreadArrays([unitPrice || { amount: 0, currency: "" }], accessoryPrices, applicableFees.map(function (f) { return f; })));
        return {
            package: {
                id: unit.id,
                name: this.getMarketingName(),
                features: this.getModelKeyFeatures(),
                price: this.formatPrice(unitPrice),
                rawprice: unitPrice,
                copy: this.getMarketingSummary()
            },
            options: options,
            accessories: {
                groups: Object.values(groupedSelectedAccessories),
                subtotal: this.formatPrice(accsum),
                rawsubtotal: accsum,
            },
            fees: {
                items: fees,
                subtotal: this.formatPrice(this.sumPrices(applicableFees))
            },
            subtotalprice: this.formatPrice(subtotalprice),
            totalprice: this.formatPrice(totalprice),
            rawsubtotalprice: subtotalprice,
            rawtotalprice: totalprice
        };
    };
    BuildSessionV2.prototype.getQualifiedUrl = function (path) {
        if (path) {
            if (path.includes(" ")) {
                console.warn("Unencoded URL: " + path);
                path = encodeURI(path);
            }
            if (path.startsWith("http://") || path.startsWith("https://")) {
                return path;
            }
            return this.session.server + path;
        }
        return undefined;
    };
    BuildSessionV2.prototype.getValidUnits = function (model, requiredFeatures, desiredFeatures) {
        var _a, _b;
        if (requiredFeatures === undefined && desiredFeatures === undefined && ((_a = this.familyCache) === null || _a === void 0 ? void 0 : _a.modelId) === model.id) {
            return this.familyCache.validUnits;
        }
        var validUnits = [];
        var units = model.units || [];
        var blacklistFailures = [];
        var dateFailures = [];
        var countryfailures = [];
        var priceFailures = [];
        var now = today();
        var _loop_5 = function (unit) {
            if ((((_b = this_4.config) === null || _b === void 0 ? void 0 : _b.blacklist) || []).includes(unit.id || "")) {
                blacklistFailures.push(unit.id);
                return "continue";
            }
            if (!checkValidityPeriod(unit, now)) {
                dateFailures.push(unit.id);
                return "continue";
            }
            if (!(sanitizeCountryList(unit.availableCountries)).includes(this_4.session.country)) {
                countryfailures.push(unit.id);
                return "continue";
            }
            var price = this_4.getPrice(unit.prices);
            if (!price) {
                priceFailures.push(unit.id);
                return "continue";
            }
            //Should check for region surcharges here
            var features = (unit.bundledFeatures || []);
            if (requiredFeatures) {
                var hasRequiredFeatures = true;
                var _loop_6 = function (requiredFeature) {
                    if (!features.find(function (f) { return f.id === requiredFeature; })) {
                        hasRequiredFeatures = false;
                        return "break";
                    }
                };
                for (var _i = 0, requiredFeatures_1 = requiredFeatures; _i < requiredFeatures_1.length; _i++) {
                    var requiredFeature = requiredFeatures_1[_i];
                    var state_2 = _loop_6(requiredFeature);
                    if (state_2 === "break")
                        break;
                }
                if (!hasRequiredFeatures) {
                    return "continue";
                }
            }
            var matches = [];
            if (desiredFeatures) {
                matches = desiredFeatures.filter(function (f) { return features.find(function (bf) { return bf.id === f.featureid; }); });
            }
            validUnits.push({ unit: unit, matches: matches, price: price.amount });
        };
        var this_4 = this;
        for (var _i = 0, units_1 = units; _i < units_1.length; _i++) {
            var unit = units_1[_i];
            _loop_5(unit);
        }
        if (DEBUG) {
            // log unit failures per category
            if (blacklistFailures.length > 0) {
                console.log("Unit blacklist failures: ", blacklistFailures);
            }
            if (dateFailures.length > 0) {
                console.log("Unit date failures: ", dateFailures);
            }
            if (countryfailures.length > 0) {
                console.log("Unit country failures: ", countryfailures);
            }
            if (priceFailures.length > 0) {
                console.log("Unit price failures: ", priceFailures);
            }
        }
        return validUnits;
    };
    BuildSessionV2.prototype.setOption = function (category, id) {
        var _this = this;
        var prevUnit = this.getUnit();
        var requiredFeatures = __spreadArrays([id], this.state.selected.filter(function (o) { return o.featureid !== undefined && BLOCKED_OPTION_GROUPS.includes(o.category); }).map(function (o) { return o.featureid; }));
        //Try and find another unit model that contains the selected features
        var desiredFeatures = this.state.selected.filter(function (o) { return o.featureid !== undefined && o.category !== category && !EXCLUDED_OPTION_GROUPS.includes(o.category); });
        if (desiredFeatures.find(function (f) { return f.featureid === id; })) {
            return; //Already selected
        }
        var validUnits = this.getValidUnits(this.getUnitModel(), requiredFeatures, desiredFeatures);
        if (Object.keys(validUnits).length === 0) {
            console.error("No available sku contains the requested feature");
            this.onConflict(this.generateConflictDetails(api_1.Action.ChangedFeature, id, []));
            return;
        }
        validUnits.sort(function (r, l) { return (l.matches.length - r.matches.length); });
        var includedAccessories = {};
        for (var _i = 0, validUnits_1 = validUnits; _i < validUnits_1.length; _i++) {
            var target = validUnits_1[_i];
            if (target.unit.id) {
                includedAccessories[target.unit.id] = this.getIncludedAccessories(target.unit);
            }
        }
        if (prevUnit.id && !includedAccessories[prevUnit.id]) {
            includedAccessories[prevUnit.id] = this.getIncludedAccessories(prevUnit);
        }
        var solutions = validUnits.map(function (target) {
            var _a;
            if (!target.unit.id) {
                throw new Error("Invalid unit");
            }
            var targetUnitId = target.unit.id;
            var prevFeatures = prevUnit.bundledFeatures || [];
            var nextFeatures = target.unit.bundledFeatures || [];
            var addFeatures = nextFeatures.filter(function (f) { return f && f.id && !prevFeatures.find(function (bf) { return bf.id === f.id; }); }).map(function (f) { return f.id; });
            var removeFeatures = prevFeatures.filter(function (f) { return f && f.id && !nextFeatures.find(function (bf) { return bf.id === f.id; }); }).map(function (f) { return f.id; });
            var state = _this.getCurrentState().filter(function (id) { return !removeFeatures.includes(id); }).concat(addFeatures);
            //Add any bundled accessories
            var add = [];
            var _loop_7 = function (accessory) {
                if (accessory.id) {
                    var expected = _this.getQuantityRange(accessory).minimum;
                    var existing = _this.state.selected.find(function (s) { return s.accessorysku === accessory.id; });
                    var current = existing ? existing.quantity : 0;
                    for (var i = current; i < expected; ++i) {
                        add.push(accessory.id);
                    }
                }
            };
            for (var _i = 0, _b = includedAccessories[targetUnitId]; _i < _b.length; _i++) {
                var accessory = _b[_i];
                _loop_7(accessory);
            }
            //Remove any locked accessories (assuming there not also on the new one)
            var remove = _this.state.selected.map(function (s) {
                var remove = [];
                if (s.accessorysku !== undefined && s.locked > 0) {
                    var included = includedAccessories[targetUnitId].find(function (a) { return a.id === s.accessorysku; });
                    var required = included ? _this.getQuantityRange(included).minimum : 0;
                    for (var current = s.locked; current > required; --current) {
                        remove.push(s.accessorysku);
                    }
                }
                return remove;
            }).reduce(function (prev, curr) { return prev.concat(curr); }, []);
            //Remove any other accessories not on the new one
            remove = remove.concat(_this.state.selected.filter(function (s) { return s.accessorysku !== undefined && !remove.includes(s.accessorysku) && !(includedAccessories[targetUnitId].find(function (a) { return a.id === s.accessorysku; }) ||
                (target.unit.availableAccessories || []).find(function (a) { return a.id === s.accessorysku; })); }).map(function (s) { return s.accessorysku; }));
            var solution = {
                add: addFeatures,
                remove: removeFeatures,
                targetUnitId: target.unit.id
            };
            var solutions = _this.resolve(target.unit, state, remove, add, (_a = {}, _a[_this.getSolutionKey(solution)] = solution, _a), false);
            if (solutions) {
                return _this.resolveExisting(target.unit, state, solutions, false);
            }
            return undefined;
        }).reduce(this.mergeSolutions, {});
        var filteredSolutions = Object.values(this.filterSolutions(solutions));
        var prevIncludedAccessories = (prevUnit.id ? includedAccessories[prevUnit.id] : []).map(function (a) { return a.id || ""; });
        var autoApply = filteredSolutions.find(function (s) {
            //Should ignore changes to locked items too?
            var filterConfigurable = function (unit, ids, ignore) {
                if (ignore === void 0) { ignore = []; }
                return ids.filter(function (i) {
                    if (IGNORE_INCLUDED_ACCESSORY_CONFLICTS && ignore.includes(i)) {
                        return false;
                    }
                    if ((unit.availableAccessories || []).find(function (a) { return a.id === i; })) {
                        return true;
                    }
                    if ((unit.bundledFeatures || []).find(function (f) { return f.id === i && f.type && f.type.id && !EXCLUDED_OPTION_GROUPS.includes(f.type.id); })) {
                        return true;
                    }
                    return false;
                });
            };
            if (!s.targetUnitId) {
                throw new Error("Invalid Unit");
            }
            var nextUnit = _this.getUnit(s.targetUnitId);
            var nextIncludedAccessories = includedAccessories[s.targetUnitId].map(function (a) { return a.id || ""; });
            return filterConfigurable(nextUnit, s.add, nextIncludedAccessories).length === 1 && filterConfigurable(prevUnit, s.remove, prevIncludedAccessories).length === 1;
        });
        if (autoApply) {
            this.applySolution(api_1.Action.ChangedFeature, this.getFeatureItemById(id), autoApply);
        }
        else {
            this.onConflict(this.generateConflictDetails(api_1.Action.ChangedFeature, id, filteredSolutions, includedAccessories));
        }
    };
    BuildSessionV2.prototype.mergeSolutions = function (existing, toAdd) {
        if (toAdd) {
            Object.assign(existing, toAdd);
        }
        return existing;
    };
    BuildSessionV2.prototype.resolve = function (unit, state, incompatible, required, solutions, attaching, validating, restrictions) {
        if (attaching === void 0) { attaching = false; }
        if (validating === void 0) { validating = false; }
        var _loop_8 = function (incompatibility) {
            var count = state.filter(function (id) { return id === incompatibility; }).length;
            if (count > 0) {
                var updatedSolutions = {};
                for (var _i = 0, _a = Object.keys(solutions); _i < _a.length; _i++) {
                    var solutionKey = _a[_i];
                    var solution = solutions[solutionKey];
                    var resolutions = this_5.resolveRemove(unit, __spreadArrays(state), incompatibility, count, solution.add, solution.remove, required, attaching, solutionKey, restrictions);
                    this_5.mergeSolutions(updatedSolutions, resolutions);
                }
                if (Object.keys(updatedSolutions).length === 0) {
                    return { value: undefined };
                }
                solutions = updatedSolutions;
            }
        };
        var this_5 = this;
        for (var _i = 0, incompatible_1 = incompatible; _i < incompatible_1.length; _i++) {
            var incompatibility = incompatible_1[_i];
            var state_3 = _loop_8(incompatibility);
            if (typeof state_3 === "object")
                return state_3.value;
        }
        var _loop_9 = function (requirement) {
            var requirementCount = state.filter(function (id) { return id === requirement; }).length;
            if (requirementCount === 0 || validating) {
                var updatedSolutions = {};
                for (var _i = 0, _a = Object.keys(solutions); _i < _a.length; _i++) {
                    var solutionKey = _a[_i];
                    var solution = solutions[solutionKey];
                    var resolutions = this_6.resolveAdd(unit, __spreadArrays(state, (validating ? required : [])), requirement, validating ? 0 : 1, solution.add, solution.remove, attaching, solutionKey, restrictions);
                    this_6.mergeSolutions(updatedSolutions, resolutions);
                    if (validating && (!resolutions || Object.keys(resolutions).length > 1 || (Object.keys(resolutions).length > 0 && (Object.values(resolutions)[0].add != solution.add || Object.values(resolutions)[0].remove != solution.remove)))) {
                        var resolutions_1 = this_6.resolveRemove(unit, __spreadArrays(state), requirement, requirementCount, solution.add, solution.remove, undefined, attaching, solutionKey, restrictions);
                        this_6.mergeSolutions(updatedSolutions, resolutions_1);
                    }
                }
                if (Object.keys(updatedSolutions).length === 0) {
                    return { value: undefined };
                }
                solutions = updatedSolutions;
            }
        };
        var this_6 = this;
        for (var _a = 0, required_1 = required; _a < required_1.length; _a++) {
            var requirement = required_1[_a];
            var state_4 = _loop_9(requirement);
            if (typeof state_4 === "object")
                return state_4.value;
        }
        return solutions;
    };
    BuildSessionV2.prototype.getAccessories = function (unit, category, onlyAvailable) {
        var _a;
        var accessoryCache = this.accessoryCache;
        if (!accessoryCache || unit.id !== this.state.unitsku) {
            accessoryCache = this.buildAccessoriesList(unit);
            if (!accessoryCache) {
                return [];
            }
        }
        if (onlyAvailable) {
            return accessoryCache.available.items;
        }
        if (category) {
            //category = category?.toLowerCase();
            return ((_a = accessoryCache.categorised[category]) === null || _a === void 0 ? void 0 : _a.items) || [];
        }
        return accessoryCache.all.items;
    };
    BuildSessionV2.prototype.getAccessoryIDs = function (unit, category, onlyAvailable) {
        var _a;
        var accessoryCache = this.accessoryCache;
        if (!accessoryCache || unit.id !== this.state.unitsku) {
            accessoryCache = this.buildAccessoriesList(unit);
            if (!accessoryCache) {
                return [];
            }
        }
        if (onlyAvailable) {
            return accessoryCache.available.ids;
        }
        if (category) {
            //category = category?.toLowerCase();
            return ((_a = accessoryCache.categorised[category]) === null || _a === void 0 ? void 0 : _a.ids) || [];
        }
        return accessoryCache.all.ids;
    };
    BuildSessionV2.prototype.buildAccessoriesList = function (unit, blacklist) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        //Should just do this on unit change and cache the results
        var allAccessories = __spreadArrays((unit.availableAccessories || []), (unit.includedAccessories || []));
        var uniqueAccessories = allAccessories.filter(function (a, index) { return allAccessories.findIndex(function (b) { return b.id === a.id; }) === index; });
        //Ignore errors with included accessories
        var includedAccessoryIds = ((_a = unit.includedAccessories) === null || _a === void 0 ? void 0 : _a.map(function (a) { return a.id; })) || [];
        //Filter accessories that are blacklisted
        var blacklistSet = new Set((blacklist || ((_b = this.config) === null || _b === void 0 ? void 0 : _b.blacklist) || []).filter(function (r) {
            var _a;
            if (typeof (r) !== "string") {
                if (r.country) {
                    if (!((_a = r.country.map(function (c) { return c.toLowerCase(); })) === null || _a === void 0 ? void 0 : _a.includes(_this.session.country.toLowerCase()))) {
                        return false;
                    }
                }
                if (!api_1.processLogic([unit.id, unit.platform || _this.getPlatformId(), _this.getPackageId()], r)) {
                    return false;
                }
            }
            return true;
        }).map(function (r) { return typeof (r) === "string" ? r : r.code; }));
        uniqueAccessories = uniqueAccessories.filter(function (a) {
            var _a, _b;
            if (blacklistSet.has(a.id || "")) {
                if (IGNORE_INCLUDED_ACCESSORY_VALIDATION && includedAccessoryIds.includes(a.id)) {
                    console.log("Ignoring override blacklisting on " + ((_a = a.name) === null || _a === void 0 ? void 0 : _a.default) + " (" + a.id + ") because its included with the unit " + unit.id);
                }
                else {
                    console.log("Removing " + ((_b = a.name) === null || _b === void 0 ? void 0 : _b.default) + " (" + a.id + ") due to override blacklist", a);
                    return false;
                }
            }
            return true;
        });
        //Filter accessories that aren't currently available
        var now = today();
        uniqueAccessories = uniqueAccessories.filter(function (a) {
            var _a, _b;
            if (!checkValidityPeriod(a, now)) {
                if (IGNORE_INCLUDED_ACCESSORY_VALIDATION && includedAccessoryIds.includes(a.id)) {
                    console.log("Ignoring valitity period on " + ((_a = a.name) === null || _a === void 0 ? void 0 : _a.default) + " (" + a.id + ") because its included with the unit " + unit.id);
                }
                else {
                    console.log("Removing " + ((_b = a.name) === null || _b === void 0 ? void 0 : _b.default) + " (" + a.id + ") due to validity dates", a);
                    return false;
                }
            }
            return true;
        });
        //Filter accessories that aren't available in the current country
        uniqueAccessories = uniqueAccessories.filter(function (a) {
            var _a, _b, _c, _d;
            if (sanitizeCountryList(a.excludedCountries).includes(_this.session.country)) {
                if (IGNORE_INCLUDED_ACCESSORY_VALIDATION && includedAccessoryIds.includes(a.id)) {
                    console.log("Ignoring excludedCountries blacklist on " + ((_a = a.name) === null || _a === void 0 ? void 0 : _a.default) + " (" + a.id + ") because its included with the unit " + unit.id);
                }
                else {
                    if (!ALLOW_FALLBACK)
                        console.log("Removing " + ((_b = a.name) === null || _b === void 0 ? void 0 : _b.default) + " (" + a.id + ") due to excludedCountries blacklist", a);
                    return false;
                }
            }
            if (a.includedCountries && !sanitizeCountryList(a.includedCountries).includes(_this.session.country)) {
                if (IGNORE_INCLUDED_ACCESSORY_VALIDATION && includedAccessoryIds.includes(a.id)) {
                    console.log("Ignoring includedCountries whitelist on " + ((_c = a.name) === null || _c === void 0 ? void 0 : _c.default) + " (" + a.id + ") because its included with the unit " + unit.id);
                }
                else {
                    if (!ALLOW_FALLBACK)
                        console.log("Removing " + ((_d = a.name) === null || _d === void 0 ? void 0 : _d.default) + " (" + a.id + ") due to includedCountries whitelist", a);
                    return false;
                }
            }
            return true;
        });
        //Filter accessories that have unresolvable dependencies
        var availableAccessoryIds = uniqueAccessories.map(function (a) { return a.id; });
        var accessoryCharacteristics = uniqueAccessories.reduce(function (o, a) {
            var _a;
            var _b;
            return (__assign(__assign({}, o), (_a = {}, _a[a.id || ""] = ((_b = a.category) === null || _b === void 0 ? void 0 : _b.map(function (c) { return c.id || ""; })) || [], _a)));
        }, {});
        availableAccessoryIds.push(NONE);
        var lastLength = availableAccessoryIds.length;
        var pass = 0;
        while (lastLength > 0) {
            var _loop_10 = function (a) {
                if (!availableAccessoryIds.includes(a.id)) {
                    return "continue";
                }
                if (a.dependencies) {
                    var remove2Way = false;
                    var remove3Way = false;
                    var reasons = [];
                    if (a.dependencies.twoWay) {
                        var _loop_12 = function (groupName) {
                            var group = a.dependencies.twoWay[groupName];
                            var availableDeps = group.filter(function (d) { return availableAccessoryIds.includes(d); });
                            if (availableDeps.length === 0) {
                                remove2Way = true;
                                reasons.push("No accessories available to resolve twoWay: " + groupName + " : " + group);
                            }
                            else if (group.includes(NONE) && ((_c = a.category) === null || _c === void 0 ? void 0 : _c.find(function (g) { return g.id == groupName; })) && !group.includes(a.id)) {
                                remove2Way = true;
                                reasons.push("Self exclusion based on twoWay: " + groupName + " : " + group);
                            }
                            else if (!availableDeps.some(function (d) { return d === NONE || accessoryCharacteristics[d].includes(groupName); })) {
                                remove2Way = true;
                                reasons.push("Accessory has wrong characteristic to resolve twoWay: " + groupName + " : " + availableDeps.map(function (d) { return d + "=" + accessoryCharacteristics[d].join(","); }).join(" - "));
                            }
                        };
                        for (var _i = 0, _a = Object.keys(a.dependencies.twoWay); _i < _a.length; _i++) {
                            var groupName = _a[_i];
                            _loop_12(groupName);
                        }
                    }
                    var exclusiveDependencies = a.dependencies.threeWay || [];
                    if (exclusiveDependencies && exclusiveDependencies.length > 0) {
                        var groups = exclusiveDependencies.reduce(function (prev, tw) {
                            var valid = (availableAccessoryIds.includes(tw[0].accessory) && availableAccessoryIds.includes(tw[1].accessory));
                            var characteristics = tw.map(function (r) { return r.characteristic || ""; }).sort();
                            for (var _i = 0, prev_1 = prev; _i < prev_1.length; _i++) {
                                var set = prev_1[_i];
                                if (set.characteristics[0] === characteristics[0] && set.characteristics[1] === characteristics[1]) {
                                    if (valid) {
                                        set.constraints.push(tw);
                                    }
                                    //else {
                                    //	console.log("Ignoring constraint: ", tw)
                                    //}
                                    return prev;
                                }
                            }
                            return __spreadArrays(prev, [{ characteristics: characteristics, constraints: (valid ? [tw] : []) }]);
                        }, []);
                        remove3Way = groups.some(function (g) { return g.constraints.length === 0; });
                        if (remove3Way) {
                            reasons.push("No accessories to resolve threeWay: " + a.dependencies.threeWay);
                        }
                        else {
                            var failed_1 = new Set();
                            remove3Way = groups.some(function (g) { return g.constraints.every(function (tw) { return tw.some(function (r) {
                                var _a;
                                var invalid = r.accessory !== NONE && !((_a = accessoryCharacteristics[r.accessory || ""]) === null || _a === void 0 ? void 0 : _a.includes(r.characteristic || ""));
                                if (invalid) {
                                    failed_1.add(r.accessory + " does not have characteristic " + r.characteristic);
                                }
                                return invalid;
                            }); }); });
                            if (remove3Way) {
                                reasons.push("Accessories with characteristic mismatches threeWay: " + JSON.stringify(Array.from(failed_1), null, 2));
                            }
                        }
                    }
                    if (remove2Way || remove3Way) {
                        if (IGNORE_ALL_ACCESSORY_VALIDATION) {
                            console.log("Ignoring dependency errors on " + ((_d = a.name) === null || _d === void 0 ? void 0 : _d.default) + " (" + a.id + ")");
                        }
                        else if (IGNORE_INCLUDED_ACCESSORY_VALIDATION && includedAccessoryIds.includes(a.id)) {
                            console.log("Ignoring dependency errors on " + ((_e = a.name) === null || _e === void 0 ? void 0 : _e.default) + " (" + a.id + ") because its included with the unit " + unit.id);
                        }
                        else {
                            if (pass === 0) {
                                console.warn("Removing " + (a.name && a.name.default) + " (" + a.id + ") because it has unsatisfiable dependencies", { accessory: a, reasons: reasons });
                            }
                            else {
                                console.warn("Removing " + (a.name && a.name.default) + " (" + a.id + ") because it depends on other items that have been removed due to unsatisfiable dependencies", { accessory: a, reasons: reasons });
                            }
                            availableAccessoryIds.splice(availableAccessoryIds.indexOf(a.id), 1);
                        }
                    }
                }
            };
            for (var _i = 0, uniqueAccessories_1 = uniqueAccessories; _i < uniqueAccessories_1.length; _i++) {
                var a = uniqueAccessories_1[_i];
                _loop_10(a);
            }
            if (availableAccessoryIds.length === lastLength) {
                break;
            }
            lastLength = availableAccessoryIds.length;
            pass += 1;
        }
        var items = uniqueAccessories.filter(function (a) { var _a; return availableAccessoryIds.includes(a.id) || ((_a = includedAccessoryIds) === null || _a === void 0 ? void 0 : _a.includes(a.id)); });
        var availableItems = uniqueAccessories.filter(function (a) { return availableAccessoryIds.includes(a.id); });
        var accessoryCache = {
            all: {
                items: items,
                ids: items.map(function (item) { return item.id; }),
            },
            available: {
                items: availableItems,
                ids: availableItems.map(function (item) { return item.id; })
            },
            categorised: {}
        };
        for (var _h = 0, items_1 = items; _h < items_1.length; _h++) {
            var item = items_1[_h];
            if (!availableAccessoryIds.includes(item.id)) {
                continue;
            }
            for (var _j = 0, _k = item.category || []; _j < _k.length; _j++) {
                var category = _k[_j];
                if (category.id) {
                    var lowerCategory = category.id; //.toLowerCase()
                    if (!accessoryCache.categorised[lowerCategory]) {
                        accessoryCache.categorised[lowerCategory] = { items: [], ids: [] };
                    }
                    accessoryCache.categorised[lowerCategory].items.push(item);
                    accessoryCache.categorised[lowerCategory].ids.push(item.id);
                }
            }
        }
        console.assert(Object.keys(accessoryCache.categorised).length === new Set(Object.keys(accessoryCache.categorised).map(function (c) { return c.toLowerCase(); })).size, "Mixed case characteristics", Object.keys(accessoryCache.categorised));
        var skusForCharacteristics = Object.keys(accessoryCache.categorised).reduce(function (prev, characteristic) {
            prev[characteristic] = accessoryCache.categorised[characteristic].ids;
            return prev;
        }, {});
        var _loop_11 = function (accessory) {
            if (!accessory.dependencies || accessory.dependencies.optimised) {
                return "continue";
            }
            if (accessory.dependencies.twoWay) {
                var _loop_13 = function (characteristic) {
                    accessory.dependencies.twoWay[characteristic] = accessory.dependencies.twoWay[characteristic].filter(function (sku, index) { var _a; return (((_a = accessory.dependencies) === null || _a === void 0 ? void 0 : _a.twoWay) || {})[characteristic].indexOf(sku) === index; });
                };
                //Remove duplicates
                for (var _i = 0, _a = Object.keys(accessory.dependencies.twoWay); _i < _a.length; _i++) {
                    var characteristic = _a[_i];
                    _loop_13(characteristic);
                }
            }
            if (accessory.dependencies.threeWay) {
                var newDeps_1 = this_7.unrollThreeWay(accessory.id, accessoryCache.all.ids, skusForCharacteristics, accessory.dependencies.threeWay);
                accessory.dependencies.threeWay = newDeps_1.threeWay;
                if (newDeps_1.twoWay && Object.keys(newDeps_1.twoWay).length > 0) {
                    if (accessory.dependencies.twoWay) {
                        var _loop_14 = function (characteristic) {
                            if (accessory.dependencies.twoWay[characteristic]) {
                                accessory.dependencies.twoWay[characteristic] = accessory.dependencies.twoWay[characteristic].filter(function (sku) { return (newDeps_1.twoWay || {})[characteristic].includes(sku); });
                                console.assert(accessory.dependencies.twoWay[characteristic].length > 0, "Conflicting twoWay & threeWay dependencies: " + ((_f = accessory.name) === null || _f === void 0 ? void 0 : _f.default) + " (" + accessory.id + ")", accessory);
                            }
                            else {
                                accessory.dependencies.twoWay[characteristic] = newDeps_1.twoWay[characteristic];
                            }
                        };
                        for (var _b = 0, _c = Object.keys(newDeps_1.twoWay); _b < _c.length; _b++) {
                            var characteristic = _c[_b];
                            _loop_14(characteristic);
                        }
                    }
                    else {
                        accessory.dependencies.twoWay = newDeps_1.twoWay;
                    }
                }
            }
            if (accessory.dependencies.twoWay) {
                for (var _d = 0, _e = Object.keys(accessory.dependencies.twoWay); _d < _e.length; _d++) {
                    var characteristic = _e[_d];
                    accessory.dependencies.twoWay[characteristic] = accessory.dependencies.twoWay[characteristic].filter(function (sku) { var _a; return sku === NONE || ((_a = accessoryCache) === null || _a === void 0 ? void 0 : _a.all.ids.includes(sku)); });
                    if (accessory.dependencies.twoWay[characteristic].length === (((_g = skusForCharacteristics[characteristic]) === null || _g === void 0 ? void 0 : _g.length) || 0) + 1) {
                        delete accessory.dependencies.twoWay[characteristic];
                    }
                }
            }
            accessory.dependencies.optimised = true;
        };
        var this_7 = this;
        for (var _l = 0, _m = accessoryCache.all.items; _l < _m.length; _l++) {
            var accessory = _m[_l];
            _loop_11(accessory);
        }
        accessoryCache.optimisableCategories = Object.keys(accessoryCache.categorised).filter(function (c) { var _a; return !((_a = accessoryCache) === null || _a === void 0 ? void 0 : _a.categorised[c].items.some(function (i) { return i.category.length > 1; })); });
        //console.log("accessoryCache", accessoryCache.all.items.length, Object.keys(accessoryCache.categorised), Object.values(accessoryCache.categorised).map(c => c.items.length))
        //console.log("accessories:", accessoryCache.all.items.map(a => ({id: a.id, characteristics: a.category?.map(c => c.id), dependencies: a.dependencies})));
        return accessoryCache;
    };
    BuildSessionV2.prototype.getIncludedAccessories = function (unit) {
        var _this = this;
        return (unit.includedAccessories || []).filter(function (a) {
            if (a.excludedCountries && sanitizeCountryList(a.excludedCountries).includes(_this.session.country)) {
                return false;
            }
            if (a.includedCountries && !sanitizeCountryList(a.includedCountries).includes(_this.session.country)) {
                return false;
            }
            return true;
        });
    };
    BuildSessionV2.prototype.getSolutionKey = function (solution) {
        solution.add.sort();
        solution.remove.sort();
        //return JSON.stringify(solution);
        return (solution.targetUnitId || "") + ":" + solution.add.join("") + ":" + solution.remove.join("");
    };
    BuildSessionV2.prototype.resolveExisting = function (unit, existingState, solutions, attaching) {
        var _this = this;
        if (attaching === void 0) { attaching = false; }
        //Filter solutions to unique set
        var filteredSolutions = this.filterSolutions(solutions);
        console.log(window.performance.now() + " Reduced to " + Object.keys(solutions).length + " unique");
        var features = (unit.bundledFeatures || []).map(function (f) { return f.id; });
        var includedAccessories = this.getIncludedAccessories(unit).map(function (a) { return a.id; });
        var previouslyAddedItems = existingState.filter(function (id) { return !features.includes(id) && !includedAccessories.includes(id); });
        return Object.keys(filteredSolutions).reduce(function (allFixedSolutions, solutionKey) {
            var _a;
            var solution = filteredSolutions[solutionKey];
            var toValidate = previouslyAddedItems.filter(function (id) { return !solution.remove.includes(id); });
            var newState = __spreadArrays(existingState, solution.add);
            for (var _i = 0, _b = solution.remove; _i < _b.length; _i++) {
                var id = _b[_i];
                newState.splice(newState.indexOf(id), 1); //Can't use filter because we only want to remove one instance per remove code
            }
            var fixedSolutions = _this.resolve(unit, newState, [], toValidate, (_a = {}, _a[_this.getSolutionKey(solution)] = solution, _a), attaching, true);
            _this.mergeSolutions(allFixedSolutions, fixedSolutions);
            return allFixedSolutions;
        }, {});
    };
    BuildSessionV2.prototype.unrollThreeWay = function (sku, availableSkus, skusForCharacteristics, threeWay) {
        if (threeWay.some(function (tw) { return tw.length != 2; })) {
            return { threeWay: threeWay }; //Already unrolled
        }
        var groups = threeWay.reduce(function (prev, tw) {
            var characteristics = tw.map(function (r) { return r.characteristic || ""; }).sort();
            var valid = (tw[0].accessory === NONE || availableSkus.includes(tw[0].accessory)) && (tw[1].accessory === NONE || availableSkus.includes(tw[1].accessory));
            for (var _i = 0, prev_2 = prev; _i < prev_2.length; _i++) {
                var set = prev_2[_i];
                if (set.characteristics[0] === characteristics[0] && set.characteristics[1] === characteristics[1]) {
                    if (valid) {
                        if (!set.constraints.find(function (existing) { return existing[0].characteristic === tw[0].characteristic && existing[0].accessory === tw[0].accessory && existing[1].characteristic === tw[1].characteristic && existing[1].accessory === tw[1].accessory; })) {
                            set.constraints.push(tw);
                        }
                    }
                    return prev;
                }
            }
            return __spreadArrays(prev, [{ characteristics: characteristics, constraints: valid ? [tw] : [] }]);
        }, []);
        if (groups.some(function (g) { return g.constraints.length === 0; })) {
            console.error("Unsatisfiable Dependencies", threeWay);
            return { threeWay: [] };
        }
        //console.log(sku + " Original 3 Way:", threeWay)
        //Filter constraints that offer all combinations (including None)?
        groups = groups.filter(function (group) {
            var _a, _b;
            var max = ((((_a = skusForCharacteristics[group.characteristics[0]]) === null || _a === void 0 ? void 0 : _a.length) || 0) + 1) * ((((_b = skusForCharacteristics[group.characteristics[1]]) === null || _b === void 0 ? void 0 : _b.length) || 0) + 1);
            return group.constraints.length < max;
        });
        //If there is no overlap on either characteristic with other groups, and the group allows every combination of the specified ids, convert them to twoWays
        var twoWay = {};
        var characteristicUsage = groups.reduce(function (usage, group) {
            for (var _i = 0, _a = group.characteristics; _i < _a.length; _i++) {
                var characteristic = _a[_i];
                if (usage[characteristic] === undefined) {
                    usage[characteristic] = new Set();
                }
                usage[characteristic].add(group.characteristics.join());
            }
            return usage;
        }, {});
        var characteristicVariants = groups.reduce(function (variants, group) {
            for (var _i = 0, _a = group.constraints; _i < _a.length; _i++) {
                var constraintPair = _a[_i];
                for (var _b = 0, constraintPair_1 = constraintPair; _b < constraintPair_1.length; _b++) {
                    var constraint = constraintPair_1[_b];
                    if (variants[constraint.characteristic] === undefined) {
                        variants[constraint.characteristic] = new Set();
                    }
                    variants[constraint.characteristic].add(constraint.accessory);
                }
            }
            return variants;
        }, {});
        groups = groups.filter(function (group) {
            if (characteristicUsage[group.characteristics[0]].size > 1 || characteristicUsage[group.characteristics[1]].size > 1) {
                return true; //Unsafe to do this before the unroll if there are multiple things that use these characteristics
            }
            var max = (characteristicVariants[group.characteristics[0]].size || 0) * (characteristicVariants[group.characteristics[1]].size || 0);
            if (group.constraints.length === max) {
                twoWay[group.characteristics[0]] = Array.from(characteristicVariants[group.characteristics[0]]);
                twoWay[group.characteristics[1]] = Array.from(characteristicVariants[group.characteristics[1]]);
                return false;
            }
            return true;
        });
        var allCharacteristics = threeWay.reduce(function (prev, curr) { return __spreadArrays(prev, curr.map(function (r) { return r.characteristic || ""; })); }, []);
        var characteristicCounts = allCharacteristics.reduce(function (totals, characteristic) {
            var _a;
            return (__assign(__assign({}, totals), (_a = {}, _a[characteristic] = (totals[characteristic] || 0) + 1, _a)));
        }, {});
        var sortedGroups = groups.sort(function (lhs, rhs) {
            return (characteristicCounts[lhs.characteristics[0]] * characteristicCounts[lhs.characteristics[1]]) - (characteristicCounts[rhs.characteristics[0]] * characteristicCounts[rhs.characteristics[1]]);
        });
        //console.log("Groups: ", sortedGroups)
        var step = function (remainingGroups, solutions) {
            var group = remainingGroups[0];
            if (group === undefined) {
                return solutions;
            }
            var otherGroups = remainingGroups.slice(1);
            if (solutions.length === 0) {
                return step(otherGroups, group.constraints);
            }
            var updatedSolutions = [];
            var _loop_15 = function (c0, c1) {
                var _loop_16 = function (solution) {
                    var conflict = solution.some(function (c) { return (c.characteristic === c0.characteristic && c.accessory !== c0.accessory) || (c.characteristic === c1.characteristic && c.accessory !== c1.accessory); });
                    if (!conflict) {
                        var newCharacteristics = [c0, c1].filter(function (c) { return solution.find(function (ec) { return c.characteristic === ec.characteristic; }) === undefined; });
                        updatedSolutions = __spreadArrays(updatedSolutions, step(otherGroups, [__spreadArrays(solution, newCharacteristics)]));
                    }
                    else {
                        //console.log("conflict", solution, c0, c1);
                    }
                };
                for (var _i = 0, solutions_1 = solutions; _i < solutions_1.length; _i++) {
                    var solution = solutions_1[_i];
                    _loop_16(solution);
                }
            };
            //console.log("Group:", group)
            for (var _i = 0, _a = group.constraints; _i < _a.length; _i++) {
                var _b = _a[_i], c0 = _b[0], c1 = _b[1];
                _loop_15(c0, c1);
            }
            return updatedSolutions;
        };
        var combinations = step(sortedGroups, []);
        //console.log(sku + " Expanded 3 Way:", combinations)
        //const uniqueCharacteristics = new Set(allCharacteristics);
        //console.assert(combinations.every(c => c.length == uniqueCharacteristics.size), sku + " Some combinations don't include all characteristics", uniqueCharacteristics);
        //If all threeWay's include a common dependency, convert it to a twoWay dependency
        characteristicVariants = combinations.reduce(function (variants, group) {
            for (var _i = 0, group_1 = group; _i < group_1.length; _i++) {
                var constraint = group_1[_i];
                if (variants[constraint] === undefined) {
                    variants[constraint] = new Set();
                }
                variants[constraint].add(constraint.accessory);
            }
            return variants;
        }, {});
        for (var _i = 0, _a = Object.keys(characteristicVariants); _i < _a.length; _i++) {
            var characteristic = _a[_i];
            var variants = characteristicVariants[characteristic];
            if (variants.size === 1) {
                twoWay[characteristic] = Array.from(variants);
            }
        }
        return { threeWay: combinations.map(function (c) { return c.sort(function (l, r) { return l.characteristic.localeCompare(r.characteristic); }); }), twoWay: twoWay };
    };
    BuildSessionV2.prototype.resolveAdd = function (unit, state, sku, quantity, add, remove, attaching, prevSolutionKey, restrictions) {
        var _a, _b, _c;
        var _this = this;
        var _d, _e;
        if (remove.includes(sku)) {
            return undefined; //cannot be resolved on this branch
        }
        if (DEBUG) {
            touchedAccessories.add(sku);
        }
        if (add.includes(sku)) {
            var prevSolution = { targetUnitId: unit.id, add: add, remove: remove };
            return _a = {}, _a[prevSolutionKey || this.getSolutionKey(prevSolution)] = prevSolution, _a;
        }
        add = __spreadArrays(add);
        for (var i = 0; i < quantity; ++i) {
            state.push(sku);
            add.push(sku);
        }
        var solution = { add: add, remove: remove, targetUnitId: unit.id };
        var solutions = (_b = {}, _b[this.getSolutionKey(solution)] = solution, _b);
        var allAccessories = this.getAccessories(unit);
        var item = allAccessories.find(function (a) { return a.id === sku; });
        if (!item) {
            //throw Error("Unknown accessory: " + sku)
            console.error("Trying to add an accessory we can't find in available list!", sku, unit.id);
            return undefined;
        }
        if (((_d = this.config) === null || _d === void 0 ? void 0 : _d.optimise) && restrictions && ((_e = item.category) === null || _e === void 0 ? void 0 : _e.length)) {
            restrictions = __assign(__assign({}, restrictions), (_c = {}, _c[item.category[0].id] = sku, _c));
        }
        if (item.dependencies) {
            var _f = [item.dependencies.twoWay || {}, item.dependencies.threeWay || []], commonDependancies = _f[0], exclusiveDependencies = _f[1];
            if (commonDependancies && !DEBUG_IGNORE_2WAY) {
                //console.log("Processing 2 way deps on " + sku)
                var characteristics = Object.keys(commonDependancies);
                var _loop_17 = function (category) {
                    var deps = commonDependancies[category];
                    // only include accessories we know about, filters out ids we don't know about
                    var thiscat = deps.filter(function (id) { var _a; return id !== NONE && allAccessories.find(function (a) { return a.id === id; }) && (!((_a = restrictions) === null || _a === void 0 ? void 0 : _a[category]) || restrictions[category] === id); });
                    // if a NONE field appears, then anything else from this category not listed in this deps list would need to be removed
                    if (deps.includes(NONE)) {
                        var incompatible = this_8.getAccessoryIDs(unit, category).filter(function (id) { return !thiscat.includes(id) && state.includes(id); });
                        if (incompatible.length > 0) {
                            var updatedSolutions = this_8.resolve(unit, state, incompatible, [], solutions, attaching, false, restrictions);
                            if (updatedSolutions === undefined) {
                                return { value: undefined };
                            }
                            solutions = updatedSolutions;
                        }
                    }
                    else if (deps.length > 0) {
                        // if we already have something valid from this category, we don't need to add anything
                        if (thiscat.find(function (id) { return state.includes(id); })) {
                            return "continue";
                        }
                        if (!this_8.getAccessoryIDs(unit, category).some(function (id) { return thiscat.includes(id); })) {
                            return { value: undefined };
                        }
                        var updatedSolutions = {};
                        for (var _i = 0, thiscat_1 = thiscat; _i < thiscat_1.length; _i++) {
                            var option = thiscat_1[_i];
                            this_8.mergeSolutions(updatedSolutions, this_8.resolve(unit, state, [], [option], solutions, attaching, false, restrictions));
                        }
                        if (Object.keys(updatedSolutions).length === 0) {
                            return { value: undefined };
                        }
                        solutions = updatedSolutions;
                    }
                };
                var this_8 = this;
                for (var _i = 0, characteristics_1 = characteristics; _i < characteristics_1.length; _i++) {
                    var category = characteristics_1[_i];
                    var state_5 = _loop_17(category);
                    if (typeof state_5 === "object")
                        return state_5.value;
                }
            }
            if (exclusiveDependencies && exclusiveDependencies.length > 0 && !DEBUG_IGNORE_3WAY) {
                //Check to see if any of the solutions is already applied before recursively gathering them
                var resolved = false;
                for (var _g = 0, exclusiveDependencies_1 = exclusiveDependencies; _g < exclusiveDependencies_1.length; _g++) {
                    var exclusive = exclusiveDependencies_1[_g];
                    resolved = true;
                    var _loop_18 = function (category) {
                        if (!category.characteristic) {
                            console.warn("Ignoring category with unspecified characteristic");
                            return "continue";
                        }
                        var options = this_9.getAccessoryIDs(unit, category.characteristic);
                        if (category.accessory === NONE) {
                            if (state.some(function (id) { return options.includes(id); })) {
                                resolved = false;
                                return "break";
                            }
                        }
                        else if (category.accessory) {
                            if (!state.includes(category.accessory)) {
                                resolved = false;
                                return "break";
                            }
                        }
                    };
                    var this_9 = this;
                    for (var _h = 0, exclusive_1 = exclusive; _h < exclusive_1.length; _h++) {
                        var category = exclusive_1[_h];
                        var state_6 = _loop_18(category);
                        if (state_6 === "break")
                            break;
                    }
                    if (resolved) {
                        break;
                    }
                }
                if (!resolved) {
                    //console.log("Processing 3 way deps on " + sku)
                    var exclusiveSolutions_1 = {};
                    exclusiveDependencies.forEach(function (exclusive) {
                        var _a, _b, _c, _d;
                        var required = [];
                        var incompatible = [];
                        for (var _i = 0, exclusive_2 = exclusive; _i < exclusive_2.length; _i++) {
                            var category = exclusive_2[_i];
                            if (!category.characteristic) {
                                return;
                            }
                            if (((_a = _this.config) === null || _a === void 0 ? void 0 : _a.optimise) && ((_c = (_b = _this.accessoryCache) === null || _b === void 0 ? void 0 : _b.optimisableCategories) === null || _c === void 0 ? void 0 : _c.includes(category.characteristic)) && ((_d = restrictions) === null || _d === void 0 ? void 0 : _d[category.characteristic]) && restrictions[category.characteristic] !== category.accessory) {
                                return;
                            }
                            var options = _this.getAccessoryIDs(unit, category.characteristic);
                            if (category.accessory === NONE) {
                                incompatible = incompatible.concat(options);
                            }
                            else if (category.accessory) {
                                if (options.includes(category.accessory)) {
                                    required.push(category.accessory);
                                }
                                else {
                                    try {
                                        console.error("Ignoring potential solution with miscategorised accessory", category, options, _this.getAccessoryItemBySku(unit, category.accessory));
                                    }
                                    catch (_e) {
                                        //console.warn("Ignoring potential solution with unknown accessory", category, options)
                                    }
                                    return;
                                }
                            }
                            else {
                                console.log("Ignoring potential solution with unspecified accessory");
                                return;
                            }
                        }
                        if (required.length > 0 || incompatible.length > 0) {
                            //Should hopefully never happen, but ignore any ignored items that are explicitly required
                            incompatible = incompatible.filter(function (id) { return !required.includes(id); });
                            var filteredSolutions = Object.keys(solutions).reduce(function (reducedSolutions, key) {
                                var s = solutions[key];
                                if (!(s.add.some(function (a) { return incompatible.includes(a); }) || s.remove.some(function (r) { return required.includes(r); }))) {
                                    reducedSolutions[key] = s;
                                }
                                return reducedSolutions;
                            }, {});
                            _this.mergeSolutions(exclusiveSolutions_1, _this.resolve(unit, state, incompatible, required, filteredSolutions, attaching, false, restrictions));
                        }
                    });
                    if (Object.keys(exclusiveSolutions_1).length === 0) {
                        return undefined;
                    }
                    solutions = exclusiveSolutions_1;
                }
            }
        }
        return solutions;
    };
    BuildSessionV2.prototype.getDependants = function (state, accessories, sku, ignore) {
        var dependents = [];
        var _loop_19 = function (selected) {
            if (ignore.includes(selected)) {
                return "continue";
            }
            var accessory = accessories.find(function (a) { return a.id === selected; });
            if (accessory && accessory.dependencies) {
                var _a = [accessory.dependencies.twoWay || {}, accessory.dependencies.threeWay || []], common = _a[0], exclusive = _a[1];
                var dependentCommon = Object.values(common).some(function (group) {
                    return group.includes(sku) && !group.includes(NONE) && !group.some(function (g) { return state.includes(g); });
                });
                var dependantExclusive = (exclusive && exclusive.length > 0 && !exclusive.some(function (group) {
                    var _loop_20 = function (item) {
                        if (!item.accessory) {
                            return "continue";
                        }
                        if (item.accessory === NONE) {
                            //Check no items of the group exist in state
                            var cgroup = accessories.filter(function (a) { return a.id && a.category && a.category.find(function (c) { return c.id === item.characteristic; }); }).map(function (a) { return a.id; });
                            if (cgroup.some(function (a) { return state.includes(a); })) {
                                return { value: false };
                            }
                        }
                        else if (!state.includes(item.accessory)) {
                            return { value: false };
                        }
                    };
                    for (var _i = 0, group_2 = group; _i < group_2.length; _i++) {
                        var item = group_2[_i];
                        var state_8 = _loop_20(item);
                        if (typeof state_8 === "object")
                            return state_8.value;
                    }
                    return true;
                }));
                if (dependentCommon || dependantExclusive) {
                    dependents.push(selected);
                }
            }
        };
        for (var _i = 0, state_7 = state; _i < state_7.length; _i++) {
            var selected = state_7[_i];
            _loop_19(selected);
        }
        return dependents;
    };
    BuildSessionV2.prototype.resolveRemove = function (unit, state, sku, quantity, add, remove, pendingAdd, attaching, prevSolutionKey, restrictions) {
        var _a, _b, _c;
        if (pendingAdd === void 0) { pendingAdd = []; }
        var _d;
        if (add.includes(sku)) {
            return undefined; //cannot be resolved on this branch
        }
        touchedAccessories.add(sku);
        if (remove.includes(sku)) {
            var prevSolution = { add: add, remove: remove, targetUnitId: unit.id };
            return _a = {}, _a[prevSolutionKey || this.getSolutionKey(prevSolution)] = prevSolution, _a;
        }
        if (!attaching) {
            var includedAccessory = this.getIncludedAccessories(unit).find(function (a) { return a.id === sku; });
            if (includedAccessory) {
                var minimum = (((_d = includedAccessory.quantityRange) === null || _d === void 0 ? void 0 : _d.minvalue) || 1);
                var available = state.filter(function (id) { return sku === id; }).length;
                if (available > minimum) {
                    quantity = Math.min(quantity, available - minimum);
                }
                else {
                    //Don't force the removal of an included accessory
                    var solution_1 = { add: add, remove: remove, targetUnitId: unit.id };
                    return _b = {}, _b[this.getSolutionKey(solution_1)] = solution_1, _b;
                }
            }
        }
        remove = __spreadArrays(remove);
        for (var i = 0; i < quantity; ++i) {
            state.splice(state.findIndex(function (i) { return i === sku; }), 1);
            remove.push(sku);
        }
        var allAccessories = this.getAccessories(unit);
        var dependents = [];
        if (!state.includes(sku)) {
            dependents = this.getDependants(__spreadArrays(state, pendingAdd), allAccessories, sku, __spreadArrays(add, pendingAdd));
        }
        //Remove any accessories that are left in the build that don't have grouping info and are no longer depended on by anything else
        //This might be dodgy - should we only do this after processing all dependencies - after resolveExisting, otherwise future adds that try to readd it will fail
        var appliedAccessories = state.filter(function (s) { return !dependents.includes(s); }).map(function (s) { return allAccessories.find(function (a) { return a.id === s; }); }).filter(function (a) { return a !== undefined; });
        var ungroupedAccessories = appliedAccessories.filter(function (a) { return a && (!a.type || !a.type.id); });
        if (ungroupedAccessories.length > 0) {
            var changed = true;
            while (changed) {
                changed = false;
                var _loop_21 = function (ua) {
                    if (!ua || !ua.id) {
                        return "continue";
                    }
                    if (this_10.getDependants(appliedAccessories.map(function (aa) { return aa.id || ""; }).filter(function (id) { return id !== "" && id !== ua.id; }), appliedAccessories, ua.id, add).length === 0) {
                        dependents.push(ua.id);
                        appliedAccessories.splice(appliedAccessories.indexOf(ua), 1);
                        ungroupedAccessories.splice(ungroupedAccessories.indexOf(ua), 1);
                        changed = true;
                        return "break";
                    }
                };
                var this_10 = this;
                for (var _i = 0, ungroupedAccessories_1 = ungroupedAccessories; _i < ungroupedAccessories_1.length; _i++) {
                    var ua = ungroupedAccessories_1[_i];
                    var state_9 = _loop_21(ua);
                    if (state_9 === "break")
                        break;
                }
            }
        }
        var solution = { add: add, remove: remove, targetUnitId: unit.id };
        var solutions = (_c = {}, _c[this.getSolutionKey(solution)] = solution, _c);
        if (dependents.length > 0) {
            var updatedSolutions = this.resolve(unit, state, dependents, [], solutions, attaching, false, restrictions);
            if (!updatedSolutions) {
                return undefined;
            }
            solutions = updatedSolutions;
        }
        return solutions;
    };
    BuildSessionV2.prototype.getFeatureItemById = function (id) {
        var feature = this.getUnitFeatures(this.getUnitModel()).find(function (f) { return f.id === id; });
        if (feature) {
            return this.getFeatureItem(feature);
        }
        throw new Error("Feature not found: " + id);
    };
    BuildSessionV2.prototype.getFeatureItem = function (feature) {
        var _this = this;
        var selected = this.state.selected.find(function (o) { return o.featureid === feature.id; });
        return {
            id: feature.id || "",
            name: this.getTranslation(feature.name),
            categoryId: feature.type && feature.type.id,
            description: this.getTranslation(feature.description),
            price: "",
            icon: this.getQualifiedUrl(this.getTranslatedUrl(feature.imageUrl)),
            deselectable: false,
            selected: selected ? selected.quantity : 0,
            onAdd: this.locked() ? noop : function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(feature.id && feature.type && feature.type.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setOption(feature.type.id, feature.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            }); }); },
            onClick: this.locked() ? noop : function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(feature.id && feature.type && feature.type.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setOption(feature.type.id, feature.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            }); }); },
            analyticsName: this.getTranslation(feature.name, "en-US")
        };
    };
    BuildSessionV2.prototype.getAccessoryItemBySku = function (unit, sku, negatePrice) {
        var accessory = this.getAccessories(unit).find(function (a) { return a.id === sku; });
        if (accessory) {
            return this.getAccessoryItem(accessory, negatePrice);
        }
        throw new Error("Accessory not found: " + sku);
    };
    BuildSessionV2.prototype.getQuantityRange = function (accessory) {
        //Uncap the limits, the only things that currently have values above 1 are things that we don't handle separately anyway (such as wheel trims)
        return {
            minimum: accessory.quantityRange && accessory.quantityRange.minvalue || 1,
            maximum: accessory.quantityRange && accessory.quantityRange.maxvalue //undefined
        };
    };
    BuildSessionV2.prototype.getValidAttachPoints = function (accessory) {
        var _a;
        var attachPoints = ((_a = accessory.category) === null || _a === void 0 ? void 0 : _a.map(function (c) { return c.id; })) || [];
        //Hacks to avoid item placement in locations that we haven't configured 3d for
        var remappedAttachPoints = attachPoints.map(function (ap) { return ATTACH_POINT_ALIASES[ap] || ap; });
        if (remappedAttachPoints.find(function (ap) { return PREFERRED_ATTACH_POINTS.includes(ap); })) {
            return PREFERRED_ATTACH_POINTS.filter(function (ap) { return remappedAttachPoints.includes(ap); });
        }
        return remappedAttachPoints;
    };
    BuildSessionV2.prototype.getAccessoryItem = function (accessory, negatePrice) {
        var _this = this;
        var selected = this.state.selected.find(function (o) { return o.accessorysku === accessory.id; });
        var locked = selected && selected.locked;
        return __assign(__assign({ id: accessory.id || "", categoryId: accessory.type && accessory.type.id, name: this.getTranslation(accessory.name), description: this.getTranslation(accessory.description), icon: this.getQualifiedUrl(this.getTranslatedUrl(accessory.image)), content: __spreadArrays([this.getTranslatedUrl(accessory.external)].filter(function (i) { return i; }).map(function (i) { return ({ url: i }); }), [this.getQualifiedUrl(this.getTranslatedUrl(accessory.video))].filter(function (i) { return i; }).map(function (i) { return ({ video: i }); }), [this.getQualifiedUrl(this.getTranslatedUrl(accessory.image))].filter(function (i) { return i; }).map(function (i) { return ({ image: i }); })), price: locked ? undefined : this.formatPrice(this.getPrice(accessory.prices), negatePrice), deselectable: true, selected: selected ? selected.quantity : 0, locked: locked }, this.getQuantityRange(accessory)), { validAttachPoints: this.getValidAttachPoints(accessory), attachedPoints: selected && selected.attached, onAdd: this.locked() ? noop : function (quantity) { if (accessory.id) {
                _this.addAccessory(accessory.id, quantity);
            } }, onRemove: this.locked() ? noop : function (quantity) { if (accessory.id) {
                _this.removeAccessory(accessory.id, quantity);
            } }, onClick: (this.locked() || (selected && selected.locked)) ? noop : function () { if (accessory.id) {
                _this.toggleAccessory(accessory.id);
            } }, onAttach: (this.locked() || !selected) ? noop : function (attachPoint) { if (accessory.id) {
                _this.attachAccessory(accessory.id, attachPoint);
            } }, onDetach: (this.locked() || !selected) ? noop : function (attachPoint) { if (accessory.id) {
                _this.detachAccessory(accessory.id, attachPoint);
            } }, analyticsName: this.getTranslation(accessory.name, "en-US"), validFrom: accessory.validFrom, validTo: accessory.validTo, isNew: accessory.isNew, contains: accessory.contains });
    };
    BuildSessionV2.prototype.updateSelected = function (prevSelected, solution, mode, manuallyAdded) {
        var _this = this;
        if (mode === void 0) { mode = "normal"; }
        var prevUnit = this.getUnit();
        var nextUnit = solution.targetUnitId ? this.getUnit(solution.targetUnitId) : prevUnit;
        var prevAccessories = this.getAccessories(prevUnit);
        var accessories = this.getAccessories(nextUnit);
        var added = solution.add.filter(function (i) { return accessories.find(function (a) { return a.id === i; }); }).map(function (i) { return _this.getAccessoryItemBySku(nextUnit, i); });
        var repurposedAttachPoints = added.map(function (a) { return a.validAttachPoints && a.validAttachPoints.length > 0 ? a.validAttachPoints[0] : undefined; });
        var removed = solution.remove.filter(function (i) { return prevAccessories.find(function (a) { return a.id === i; }); }).map(function (i) { return _this.getAccessoryItemBySku(prevUnit, i); });
        var increment = mode === "attachonly" ? 0 : 1;
        var groupedAdd = solution.add.reduce(function (s, i) {
            var _a;
            return (__assign(__assign({}, s), (_a = {}, _a[i] = (s[i] || 0) + increment, _a)));
        }, {});
        var groupedRemove = solution.remove.reduce(function (s, i) {
            var _a;
            return (__assign(__assign({}, s), (_a = {}, _a[i] = (s[i] || 0) + increment, _a)));
        }, {});
        var freedUpAttachPoints = [];
        var uniqueRemovedAccessories = removed.filter(function (a, i) { return removed.findIndex(function (ra) { return ra.id == a.id; }) === i; });
        for (var _i = 0, uniqueRemovedAccessories_1 = uniqueRemovedAccessories; _i < uniqueRemovedAccessories_1.length; _i++) {
            var a = uniqueRemovedAccessories_1[_i];
            if (a.attachedPoints && a.attachedPoints.length > 0 && a.selected) {
                if (mode === "attachonly") {
                    for (var _a = 0, _b = a.attachedPoints || []; _a < _b.length; _a++) {
                        var ap = _b[_a];
                        repurposedAttachPoints.push(ap);
                    }
                }
                for (var _c = 0, _d = a.attachedPoints.slice(a.selected - groupedRemove[a.id]); _c < _d.length; _c++) {
                    var ap = _d[_c];
                    if (!repurposedAttachPoints.includes(ap)) {
                        freedUpAttachPoints.push(ap);
                    }
                }
            }
        }
        var speculativelyReattached = [];
        var selected = __spreadArrays(prevSelected.filter(function (i) {
            //Remove any entries that were removing all instance of
            var id = i.accessorysku || i.featureid;
            if (!id) {
                return true;
            }
            return !solution.remove.includes(id) || i.quantity > groupedRemove[id];
        })
            .map(function (i) {
            //Update any entries where were adding or removing some 
            if (i.accessorysku) {
                var updates = {};
                updates.quantity = i.quantity + (groupedAdd[i.accessorysku] || 0) - (groupedRemove[i.accessorysku] || 0);
                if (mode === "normal" && i.accessorysku === manuallyAdded) {
                    updates.addedautomatically = true;
                }
                if (groupedAdd[i.accessorysku] !== undefined) {
                    //Ensure anything were adding has at least one instance attached
                    if (i.attached && i.attached.length === 0) {
                        var acc = added.find(function (a) { return a.id === i.accessorysku; });
                        if (acc) {
                            updates.attached = acc.validAttachPoints && acc.validAttachPoints.length > 0 ? [acc.validAttachPoints[0]] : [];
                        }
                    }
                }
                else if (i.attached && i.attached.length > 0 && repurposedAttachPoints.includes(i.attached[0])) {
                    //Detach anything that we need to give away the attach point
                    updates.attached = [];
                }
                else if (i.attached && i.attached.length === 0) {
                    //Reattach anything that doesn't already have something else vying for its attach point
                    var acc = accessories.find(function (a) { return a.id === i.accessorysku; });
                    if (acc) {
                        var validAttachPoints = _this.getValidAttachPoints(acc);
                        if (acc && acc.id && validAttachPoints[0]) {
                            var slot = freedUpAttachPoints.indexOf(validAttachPoints[0]);
                            if (slot >= 0) {
                                freedUpAttachPoints.splice(slot, 1); // after fitting one item, make sure we don't find any more
                                updates.attached = [validAttachPoints[0]];
                                speculativelyReattached.push(acc.id);
                            }
                        }
                    }
                }
                return __assign(__assign({}, i), updates);
            }
            return i;
        }), Object.keys(groupedAdd).filter(function (i) { return !prevSelected.find(function (s) { return s.accessorysku === i || s.featureid === i; }); }).map(function (i) {
            var acc = accessories.find(function (a) { return a.id === i; });
            if (acc) {
                var validAttachPoints = _this.getValidAttachPoints(acc);
                return {
                    accessorysku: i,
                    category: acc && acc.type && acc.type.id,
                    locked: false,
                    quantity: groupedAdd[i],
                    attached: validAttachPoints.length > 0 ? [validAttachPoints[0]] : undefined,
                    addedautomatically: mode === "normal" ? i !== manuallyAdded : undefined
                };
            }
            var feature = (nextUnit.bundledFeatures || []).find(function (f) { return f.id === i; });
            if (feature) {
                return {
                    featureid: i,
                    category: feature.type && feature.type.id,
                    locked: false,
                    quantity: 1,
                    attached: undefined
                };
            }
            throw Error("Adding unknown item: " + i);
        }));
        selected = selected.map(function (s) {
            var _a;
            if (s.accessorysku) {
                var acc = _this.getIncludedAccessories(nextUnit).find(function (a) { return s.accessorysku === a.id; });
                if (acc) {
                    s.locked = _this.getQuantityRange(acc).minimum;
                    if (!((_a = s.attached) === null || _a === void 0 ? void 0 : _a.length)) {
                        //Reattach anything that doesn't already have something else vying for its attach point
                        var validAttachPoints = _this.getValidAttachPoints(acc);
                        if (acc.id && validAttachPoints[0]) {
                            var slot = freedUpAttachPoints.indexOf(validAttachPoints[0]);
                            if (slot >= 0) {
                                freedUpAttachPoints.splice(slot, 1); // after fitting one item, make sure we don't find any more
                                s.attached = [validAttachPoints[0]];
                                speculativelyReattached.push(acc.id);
                            }
                        }
                    }
                }
                else {
                    s.locked = 0;
                }
            }
            return s;
        });
        if (mode === "normal") {
            var prohibited = repurposedAttachPoints.map(function (ap) {
                var item = prevSelected.find(function (a) { return (a.attached || []).includes(ap || ""); });
                return item ? item.accessorysku : undefined;
            }).filter(function (sku) { return sku !== undefined; });
            selected = this.resolveAttachPoints(nextUnit, selected, solution.add, prohibited, speculativelyReattached);
        }
        return selected;
    };
    BuildSessionV2.prototype.resolveAttachPoints = function (unit, selected, required, prohibited, freeChanges) {
        var _a, _b, _c;
        var _this = this;
        if (freeChanges === void 0) { freeChanges = []; }
        var accessories = this.getAccessories(unit);
        var accessorySkus = accessories.map(function (a) { return a.id; });
        //Ignore feature codes
        required = required.filter(function (sku) { return accessorySkus.includes(sku); });
        //Extend prohibited list to anything that will steal the attach point of a required item
        var requiredAttachPoints = required.map(function (sku) {
            var acc = accessories.find(function (a) { return a.id === sku; });
            if (acc) {
                var validAttachPoints = _this.getValidAttachPoints(acc);
                return validAttachPoints[0];
            }
            return undefined;
        });
        prohibited = __spreadArrays(prohibited, selected.filter(function (i) {
            if (!i.accessorysku || required.includes(i.accessorysku)) {
                return false;
            }
            var acc = accessories.find(function (a) { return a.id === i.accessorysku; });
            if (acc) {
                var validAttachPoints = _this.getValidAttachPoints(acc);
                return validAttachPoints[0] && requiredAttachPoints.includes(validAttachPoints[0]);
            }
            return false;
        }).map(function (i) { return i.accessorysku; }));
        var available = selected.map(function (i) { return i.accessorysku || i.featureid; });
        var attached = selected.filter(function (i) { return i.accessorysku && i.attached && i.attached.length > 0; }).map(function (a) { return a.accessorysku; });
        var solution = { add: [], remove: [], targetUnitId: unit.id };
        var solutions = this.resolve(unit, attached, [], required, (_a = {}, _a[this.getSolutionKey(solution)] = solution, _a), true);
        if (solutions) {
            solutions = this.resolveExisting(unit, attached, solutions, true);
            //Ignore solutions that require items not already in the basket, or that attempt to remove items we just added
            var filteredSolutions = Object.values(solutions).filter(function (s) {
                if (!s.add.every(function (a) { return available.includes(a); })) {
                    return false;
                }
                if (s.remove.some(function (a) { return required.includes(a); })) {
                    return false;
                }
                if (s.add.some(function (a) { return prohibited.includes(a); })) {
                    return false;
                }
                return true;
            });
            if (filteredSolutions.length > 0) {
                filteredSolutions.sort(function (lhs, rhs) {
                    var lhsChanges = lhs.add.filter(function (sku) { return !freeChanges.includes(sku); }).length + lhs.remove.filter(function (sku) { return !freeChanges.includes(sku); }).length;
                    var rhsChanges = rhs.add.filter(function (sku) { return !freeChanges.includes(sku); }).length + rhs.remove.filter(function (sku) { return !freeChanges.includes(sku); }).length;
                    if (lhsChanges != rhsChanges) {
                        return lhsChanges - rhsChanges;
                    }
                    return rhs.add.filter(function (sku) { return !freeChanges.includes(sku); }).length - lhs.add.filter(function (sku) { return !freeChanges.includes(sku); }).length;
                });
                if (filteredSolutions[0].add.length > 0 || filteredSolutions[0].remove.length > 0) {
                    (_b = filteredSolutions[0].add).push.apply(_b, required);
                    (_c = filteredSolutions[0].remove).push.apply(_c, prohibited);
                    selected = this.updateSelected(selected, filteredSolutions[0], "attachonly");
                }
            }
        }
        return selected;
    };
    BuildSessionV2.prototype.applySolution = function (action, item, solution, resolution) {
        var unitModel = this.getUnitModel();
        var unit = this.getUnit(solution.targetUnitId);
        var availableAccessories = (solution.targetUnitId && solution.targetUnitId !== this.state.unitsku) ? this.buildAccessoriesList(unit) : undefined;
        this.dispatchUpdate(__assign(__assign({}, this.state), { name: this.getMarketingName(unitModel, unit) || this.state.name, unitsku: solution.targetUnitId || this.state.unitsku, homologation: this.getHomologationIdFromUnit(unit), modified: new Date().toISOString(), selected: this.updateSelected(this.state.selected, solution, "normal", action === api_1.Action.AddedAccessory ? item.id : undefined) }), {
            action: action,
            item: item,
            resolution: resolution
        }, availableAccessories);
    };
    BuildSessionV2.prototype.generateConflictDetails = function (action, sku, resolutions, includedAccessories) {
        var _this = this;
        var _a, _b, _c;
        if (!IGNORE_INCLUDED_ACCESSORY_CONFLICTS) {
            includedAccessories = undefined;
        }
        this.sortSolutions(resolutions);
        var getItem = function (unit, sku, remove) {
            try {
                return _this.getAccessoryItemBySku(unit, sku, remove);
            }
            catch (_a) {
                return _this.getFeatureItemById(sku);
            }
        };
        var currUnit = this.getUnit();
        var item = getItem(currUnit, sku, action === api_1.Action.RemovedAccessory);
        var ignoreRemove = (_c = (_b = (_a = includedAccessories) === null || _a === void 0 ? void 0 : _a[currUnit.id]) === null || _b === void 0 ? void 0 : _b.map(function (i) { return i.id; }), (_c !== null && _c !== void 0 ? _c : []));
        return {
            action: action,
            item: item,
            resolutions: resolutions.map(function (r) {
                var _a, _b, _c;
                var nextUnit = r.targetUnitId ? _this.getUnit(r.targetUnitId) : currUnit;
                var add = r.add.map(function (i) { return getItem(nextUnit, i); });
                var remove = r.remove.map(function (i) { return getItem(currUnit, i, true); });
                var ignoreAdd = (_c = (_b = (_a = includedAccessories) === null || _a === void 0 ? void 0 : _a[nextUnit.id]) === null || _b === void 0 ? void 0 : _b.map(function (i) { return i.id; }), (_c !== null && _c !== void 0 ? _c : []));
                var resolution = {
                    add: add.filter(function (i) { return i.id !== sku && !ignoreAdd.includes(i.id); }),
                    remove: remove.filter(function (i) { return i.id !== sku && !ignoreRemove.includes(i.id); }),
                    unitsku: r.targetUnitId,
                    getPrice: function (financeParameters) {
                        return _this.getPricingInfo(financeParameters, add, remove, r.targetUnitId);
                    },
                    getPriceDifference: function (financeParameters) {
                        var _a, _b;
                        var oldPrice = _this.getPricingDetails(financeParameters);
                        var newPrice = _this.getPricingDetails(financeParameters, add, remove, r.targetUnitId);
                        if (oldPrice && newPrice) {
                            "";
                            var subtotalValue = newPrice.subtotalValue.amount - oldPrice.subtotalValue.amount;
                            var totalValue = newPrice.totalValue.amount - oldPrice.totalValue.amount;
                            var monthlyValue = newPrice.monthlyValue && oldPrice.monthlyValue ? ((_a = newPrice.monthlyValue) === null || _a === void 0 ? void 0 : _a.amount) - ((_b = oldPrice.monthlyValue) === null || _b === void 0 ? void 0 : _b.amount) : undefined;
                            return {
                                totalValue: totalValue,
                                subtotalValue: subtotalValue,
                                monthlyValue: monthlyValue,
                                subtotal: _this.formatPrice({ amount: subtotalValue, currency: oldPrice.subtotalValue.currency }),
                                total: _this.formatPrice({ amount: totalValue, currency: oldPrice.totalValue.currency }),
                                monthly: monthlyValue && oldPrice.monthlyValue ? _this.formatPrice({ amount: monthlyValue, currency: oldPrice.monthlyValue.currency }) : "",
                                currency: newPrice.totalValue.currency
                            };
                        }
                        return undefined;
                    },
                    apply: noop
                };
                resolution.apply = function () {
                    _this.applySolution(action, item, r, resolution);
                };
                return resolution;
            })
        };
    };
    BuildSessionV2.prototype.getCurrentState = function () {
        var _a;
        return (_a = []).concat.apply(_a, this.state.selected.map(function (i) {
            return new Array(i.quantity).fill((i.accessorysku || i.featureid));
        }));
    };
    BuildSessionV2.prototype.filterSolutions = function (solutions) {
        //Filter any duplicate solutions or unnecessarily complex solutions
        var isSubset = function (set, superset) {
            for (var _i = 0, set_1 = set; _i < set_1.length; _i++) {
                var elem = set_1[_i];
                if (!superset.includes(elem)) {
                    return false;
                }
            }
            return true;
        };
        var solutionKeys = Object.keys(solutions);
        var filteredSolutions = solutionKeys.reduce(function (filtered, solutionKey, currIndex) {
            var curr = solutions[solutionKey];
            var superceeded = solutionKeys.some(function (otherKey, otherIndex) {
                var other = solutions[otherKey];
                if (currIndex != otherIndex) {
                    if (other.add.length <= curr.add.length && other.remove.length <= curr.remove.length && isSubset(other.add, curr.add) && isSubset(other.remove, curr.remove)) {
                        if (curr.add.length === other.add.length && curr.remove.length === other.remove.length) {
                            if (currIndex > otherIndex) {
                                return true;
                            }
                        }
                        else {
                            return true;
                        }
                    }
                }
                return false;
            });
            if (!superceeded) {
                filtered[solutionKey] = curr;
            }
            return filtered;
        }, {});
        return filteredSolutions;
    };
    BuildSessionV2.prototype.findSolutionToAutoApply = function (unit, sku, solutions) {
        //If all the changes are to add items that don't have groups or were what the user actually modified, auto apply
        var autoApplyHiddenItems = false;
        var autoApply = undefined;
        var ungroupedAccessories = this.getAccessories(unit).filter(function (a) { return a.type === undefined || !a.type.id; }).map(function (a) { return a.id || ""; });
        for (var _i = 0, solutions_2 = solutions; _i < solutions_2.length; _i++) {
            var solution = solutions_2[_i];
            if (solution.remove.length !== 0 && solution.add.length !== 0) {
                continue;
            }
            var changed = solution.add.length > 0 ? solution.add : solution.remove;
            var canAutoApply = !changed.some(function (a) { return a !== sku && (!autoApplyHiddenItems || !ungroupedAccessories.includes(a)); });
            if (canAutoApply) {
                if (autoApply === undefined) {
                    autoApply = solution;
                }
                else {
                    autoApply = undefined;
                    break;
                }
            }
        }
        return autoApply;
    };
    BuildSessionV2.prototype.sortSolutions = function (solutions) {
        //Add only - sorted by price
        //Everything else - sorted by total num changes (Should we account for items that aren't displayed)
        var _this = this;
        var currUnit = this.getUnit();
        var getItem = function (unit, sku, remove) {
            try {
                return _this.getAccessoryItemBySku(unit, sku, remove);
            }
            catch (_a) {
                return _this.getFeatureItemById(sku);
            }
        };
        var _getTotalPrice = this.getTotalPrice.bind(this);
        solutions.sort(function (lhs, rhs) {
            var _a;
            var lhsUnit = _this.getUnit(lhs.targetUnitId);
            var rhsUnit = _this.getUnit(rhs.targetUnitId);
            var lhsAdd = lhs.add.map(function (sku) { return getItem(lhsUnit, sku); });
            var lhsRemove = lhs.remove.map(function (sku) { return getItem(currUnit, sku); });
            var rhsAdd = rhs.add.map(function (sku) { return getItem(rhsUnit, sku); });
            var rhsRemove = rhs.remove.map(function (sku) { return getItem(currUnit, sku); });
            //Prefer minimal feature changes
            var lhsFeatureChanges = lhsAdd.filter(function (i) { return i.deselectable === false; }).length;
            var rhsFeatureChanges = rhsAdd.filter(function (i) { return i.deselectable === false; }).length;
            if (lhsFeatureChanges !== rhsFeatureChanges) {
                return lhsFeatureChanges - rhsFeatureChanges;
            }
            if (lhsFeatureChanges > 0 || rhsFeatureChanges > 0) {
                //Prefer minimal attach point changes
                var gatherAttachPoints = function (attachPoints, item) {
                    for (var _i = 0, _a = item.validAttachPoints || []; _i < _a.length; _i++) {
                        var attachPoint = _a[_i];
                        if (!attachPoints.includes(attachPoint)) {
                            attachPoints.push(attachPoint);
                        }
                    }
                    return attachPoints;
                };
                var lhsAffectedAttachPoints = __spreadArrays(lhsAdd, lhsRemove).reduce(gatherAttachPoints, []);
                var rhsAffectedAttachPoints = __spreadArrays(rhsAdd, rhsRemove).reduce(gatherAttachPoints, []);
                if (lhsAffectedAttachPoints.length !== rhsAffectedAttachPoints.length) {
                    return lhsAffectedAttachPoints.length - rhsAffectedAttachPoints.length;
                }
            }
            //Prefer all adds or all removes (least inteferance from resolver)
            var lhsOpTypes = (lhs.add.length ? 1 : 0) + (lhs.remove.length ? 1 : 0);
            var rhsOpTypes = (rhs.add.length ? 1 : 0) + (rhs.remove.length ? 1 : 0);
            if ((lhsOpTypes === 1) !== (rhsOpTypes === 1)) {
                return lhsOpTypes - rhsOpTypes;
            }
            //Prefer items we can show 3d for
            if ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.priorityList) {
                var lhs3D = (lhs.add.filter(function (a) { var _a; return (_a = _this.config) === null || _a === void 0 ? void 0 : _a.priorityList.includes(a); }).length - lhs.remove.filter(function (a) { var _a; return (_a = _this.config) === null || _a === void 0 ? void 0 : _a.priorityList.includes(a); }).length);
                var rhs3D = (rhs.add.filter(function (a) { var _a; return (_a = _this.config) === null || _a === void 0 ? void 0 : _a.priorityList.includes(a); }).length - rhs.remove.filter(function (a) { var _a; return (_a = _this.config) === null || _a === void 0 ? void 0 : _a.priorityList.includes(a); }).length);
                if (lhs3D != rhs3D) {
                    return rhs3D - lhs3D;
                }
            }
            //Prefer lowest price
            var lhsPrice = _getTotalPrice(lhsAdd, lhsRemove, lhsUnit.id);
            var rhsPrice = _getTotalPrice(rhsAdd, rhsRemove, rhsUnit.id);
            if (lhsPrice && rhsPrice) {
                return lhsPrice.total.amount - rhsPrice.total.amount;
            }
            //Prefer least changes
            return (lhs.add.length + lhs.remove.length) - (rhs.add.length + rhs.remove.length);
        });
    };
    BuildSessionV2.prototype.addAccessory = function (sku, quantity) {
        var _this = this;
        if (DEBUG) {
            touchedAccessories = new Set();
        }
        var unit = this.getUnit();
        if (quantity === undefined) {
            var item = this.getAccessoryItemBySku(unit, sku);
            quantity = item.minimum || 1;
        }
        if (quantity <= 0) {
            console.error("Requested to add <= 0 instances");
            return;
        }
        console.log(window.performance.now() + " Start");
        var state = this.getCurrentState();
        var solutions = this.resolveAdd(unit, state, sku, quantity, [], [], false, undefined, {});
        if (solutions === undefined) {
            console.error("Failed to add " + sku + ". No solution to conflict.", state);
            this.onConflict(this.generateConflictDetails(api_1.Action.AddedAccessory, sku, []));
            return;
        }
        console.log(window.performance.now() + " Generated " + Object.keys(solutions).length + " Solutions");
        solutions = this.resolveExisting(unit, state, solutions);
        if (Object.keys(solutions).length === 0) {
            console.error("Failed to add " + sku + ". No solution to conflict.", state);
            this.onConflict(this.generateConflictDetails(api_1.Action.AddedAccessory, sku, []));
            return;
        }
        console.log(window.performance.now() + " Generated " + Object.keys(solutions).length + " Solutions after fixing existing");
        var filteredSolutions = Object.values(this.filterSolutions(solutions));
        console.log(window.performance.now() + " Filtered to " + filteredSolutions.length + " Solutions");
        if (DEBUG) {
            console.log("Touched Accessories:", touchedAccessories);
            var touchedAccessoryItems = Array.from(touchedAccessories).sort().map(function (sku) { var _a; return (_a = _this.accessoryCache) === null || _a === void 0 ? void 0 : _a.all.items.find(function (a) { return a.id === sku; }); });
            console.log("Touched Accessory Details:", touchedAccessoryItems.map(function (a) { var _a, _b, _c, _d, _e; return ({ id: (_a = a) === null || _a === void 0 ? void 0 : _a.id, name: _this.getTranslation((_b = a) === null || _b === void 0 ? void 0 : _b.name, "en-US"), characteristics: (_d = (_c = a) === null || _c === void 0 ? void 0 : _c.category) === null || _d === void 0 ? void 0 : _d.map(function (c) { return c.id; }), dependencies: (_e = a) === null || _e === void 0 ? void 0 : _e.dependencies }); }));
        }
        var autoApply = this.findSolutionToAutoApply(unit, sku, filteredSolutions);
        if (autoApply) {
            var item = this.getAccessoryItemBySku(unit, sku);
            this.applySolution(api_1.Action.AddedAccessory, item, autoApply);
        }
        else {
            this.onConflict(this.generateConflictDetails(api_1.Action.AddedAccessory, sku, filteredSolutions));
        }
    };
    BuildSessionV2.prototype.removeAccessory = function (sku, quantity) {
        if (quantity === undefined) {
            quantity = 1;
        }
        if (quantity <= 0) {
            console.error("Requested to remove <= 0 instances");
            return;
        }
        var unit = this.getUnit();
        var item = this.getAccessoryItemBySku(unit, sku);
        quantity = Math.min(quantity, (item.selected || 0) - (item.locked || 0));
        if (quantity <= 0) {
            console.warn("No unlocked instances to remove");
            return;
        }
        var state = this.getCurrentState();
        var solutions = this.resolveRemove(unit, state, sku, quantity, [], [], undefined, false);
        if (solutions === undefined) {
            console.error("Failed to remove " + sku + ". No solution to conflict.", state);
            this.onConflict(this.generateConflictDetails(api_1.Action.RemovedAccessory, sku, []));
            return;
        }
        solutions = this.resolveExisting(unit, state, solutions);
        if (Object.keys(solutions).length === 0) {
            console.error("Failed to add " + sku + ". No solution to conflict.", state);
            this.onConflict(this.generateConflictDetails(api_1.Action.RemovedAccessory, sku, []));
            return;
        }
        var filteredSolutions = Object.values(this.filterSolutions(solutions));
        var autoApply = this.findSolutionToAutoApply(unit, sku, filteredSolutions);
        if (autoApply) {
            this.applySolution(api_1.Action.RemovedAccessory, item, autoApply);
        }
        else {
            this.onConflict(this.generateConflictDetails(api_1.Action.RemovedAccessory, sku, filteredSolutions));
        }
    };
    BuildSessionV2.prototype.toggleAccessory = function (sku) {
        if (this.state.selected.find(function (a) { return a.accessorysku == sku; })) {
            this.removeAccessory(sku);
        }
        else {
            this.addAccessory(sku);
        }
    };
    BuildSessionV2.prototype.attachAccessory = function (sku, location) {
        var attachItem = this.state.selected.find(function (s) { return s.accessorysku === sku; });
        if (!attachItem) {
            throw new Error("Cannot attach an accessory that isn't added");
        }
        var unit = this.getUnit();
        var acc = this.getAccessoryItemBySku(unit, sku);
        if (!acc.validAttachPoints) {
            console.warn("No valid attach points for " + acc.name + " : " + sku);
            return;
        }
        var selected = __spreadArrays(this.state.selected);
        if (!location || !(attachItem.attached && attachItem.attached.includes(location))) {
            if (location) {
                if (!acc.validAttachPoints.includes(location)) {
                    throw new Error("Cannot attach accessory to the requested attach point");
                }
            }
            else {
                //Look for a free valid attach point
                var potentialAttachPoints = acc.validAttachPoints.filter(function (ap) { return !attachItem.attached || !attachItem.attached.includes(ap); });
                if (potentialAttachPoints.length > 0) {
                    var _loop_22 = function (ap) {
                        if (!this_11.state.selected.find(function (s) { return s.attached && s.attached.includes(ap); })) {
                            location = ap;
                            return "break";
                        }
                    };
                    var this_11 = this;
                    for (var _i = 0, potentialAttachPoints_1 = potentialAttachPoints; _i < potentialAttachPoints_1.length; _i++) {
                        var ap = potentialAttachPoints_1[_i];
                        var state_10 = _loop_22(ap);
                        if (state_10 === "break")
                            break;
                    }
                    if (!location) {
                        location = potentialAttachPoints[0];
                    }
                }
            }
            var detachItem_1 = this.state.selected.find(function (s) { return location && s.attached && s.attached.includes(location); });
            if (location) {
                selected = this.state.selected.map(function (s) {
                    if (detachItem_1 && s.accessorysku === detachItem_1.accessorysku && s.attached && location) {
                        return __assign(__assign({}, s), { attached: s.attached.filter(function (ap) { return ap !== location; }) });
                    }
                    else if (attachItem && s.accessorysku === attachItem.accessorysku && location) {
                        return __assign(__assign({}, s), { attached: __spreadArrays((s.attached || []), [location]) });
                    }
                    return s;
                });
            }
            selected = this.resolveAttachPoints(unit, selected, [sku], detachItem_1 && detachItem_1.accessorysku ? [detachItem_1.accessorysku] : []);
        }
        //Ensure the newly selected part appears last in the array to match selecting items in deltagen
        var currPos = selected.findIndex(function (s) { return s.accessorysku === sku; });
        if (currPos !== selected.length - 1) {
            var move = selected.splice(currPos, 1);
            selected.push(move[0]);
        }
        this.dispatchUpdate(__assign(__assign({}, this.state), { modified: new Date().toISOString(), selected: selected }));
    };
    BuildSessionV2.prototype.detachAccessory = function (sku, location) {
        var _this = this;
        var detachItem = this.state.selected.find(function (s) { return s.accessorysku === sku; });
        if (!detachItem) {
            throw new Error("Cannot detach an accessory that isn't added");
        }
        if (!detachItem.attached || detachItem.attached.length === 0) {
            return; //Already not attached
        }
        var freedUpAttachPoints = [];
        if (location) {
            if (!detachItem.attached.includes(location)) {
                return; //Already not attached at the specified location
            }
            freedUpAttachPoints.push(location);
        }
        else {
            freedUpAttachPoints = detachItem.attached;
        }
        var unit = this.getUnit();
        this.dispatchUpdate(__assign(__assign({}, this.state), { modified: new Date().toISOString(), selected: this.state.selected.map(function (s) {
                if (detachItem && s.accessorysku === detachItem.accessorysku && s.attached) {
                    return __assign(__assign({}, s), { attached: location ? s.attached.filter(function (ap) { return ap !== location; }) : [] });
                }
                else if (freedUpAttachPoints.length > 0 && s.accessorysku) {
                    var acc = _this.getAccessoryItemBySku(unit, s.accessorysku);
                    if (acc && acc.validAttachPoints) {
                        var aps_1 = acc.validAttachPoints.filter(function (ap) { return freedUpAttachPoints.includes(ap) && (!s.attached || !s.attached.includes(ap)); });
                        if (aps_1.length > 0) {
                            freedUpAttachPoints = freedUpAttachPoints.filter(function (ap) { return !aps_1.includes(ap); });
                            return __assign(__assign({}, s), { attached: __spreadArrays((s.attached || []), aps_1) });
                        }
                    }
                }
                return s;
            }) }));
    };
    BuildSessionV2.prototype.getOptimisationLevel = function () {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.optimise) ? 1 : 0;
    };
    return BuildSessionV2;
}());
exports.BuildSessionV2 = BuildSessionV2;
var SessionV2 = /** @class */ (function () {
    function SessionV2(userId, server, brand, country, locale, region, currency, zlservice) {
        if (zlservice === void 0) { zlservice = "stage"; }
        this.version = 2;
        this.server = server;
        this.userId = userId;
        this.brand = brand;
        this.country = country;
        this.locale = locale.replace("_", "-");
        this.region = region;
        this.currency = currency;
        this.zlservice = zlservice;
        this.id = uuid_1.default.v4();
    }
    SessionV2.prototype.requestBuilds = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, builds, index, key, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(window.parent !== window)) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.queryParentPage("brp_list_builds", "brp_build_list", 50)];
                    case 2: return [2 /*return*/, (_c.sent()).map(function (s) { return makeManagable(s); })];
                    case 3:
                        _b = _c.sent();
                        console.error("Failed to query builds from parent page, falling back to local storage but that won't work on iOS/OSX");
                        return [3 /*break*/, 4];
                    case 4:
                        builds = [];
                        try {
                            for (index = 0; index < window.localStorage.length; ++index) {
                                key = localStorage.key(index);
                                if ((_a = key) === null || _a === void 0 ? void 0 : _a.startsWith("SavedBuild.")) {
                                    data = localStorage.getItem(key);
                                    if (data) {
                                        builds.push(makeManagable(JSON.parse(data)));
                                    }
                                }
                            }
                        }
                        catch (_d) {
                            console.log("local storage unavailable for saved builds");
                        }
                        return [2 /*return*/, builds];
                }
            });
        });
    };
    SessionV2.prototype.queryParentPage = function (request, response, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var handle = undefined;
                            var listener = undefined;
                            handle = setTimeout(function () {
                                window.removeEventListener("message", listener);
                                reject("Timeout");
                            }, timeout);
                            listener = function (ev) {
                                //if(ev.origin !== document.referrer) {
                                //	return;
                                //}
                                var data = undefined;
                                try {
                                    var message = JSON.parse(ev.data);
                                    if (message.event === response) {
                                        data = message.params;
                                    }
                                    if (data) {
                                        console.log("message:", data);
                                    }
                                }
                                catch (ex) {
                                    console.log("Failed to parse a message", ev);
                                }
                                if (data) {
                                    window.removeEventListener("message", listener);
                                    if (handle !== undefined) {
                                        clearTimeout(handle);
                                        resolve(data);
                                    }
                                }
                            };
                            window.addEventListener("message", listener);
                            //post message to parent frame to request builds
                            try {
                                postMessage(request);
                            }
                            catch (ex) {
                                reject("Not embedded in an iframe" + ex);
                            }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SessionV2;
}());
exports.SessionV2 = SessionV2;
//# sourceMappingURL=v2.js.map